$(document).ready(function() {

	// //check if form's been modified. in that case it enables the update button.
	// if ($('#form_forgot_password').length){
	// 	let formBefore;
	// 	let $formstatus = $('#form_forgot_password :input');/*, formAltered = false;*/
	// 	$('#form_forgot_password #btnUpd').prop( "disabled", true );
	//
	// 	$(function() {
	// 		formBefore = $("form").serialize();
	// 	});
	//
	// 	$formstatus.change(function () {
	// 		let changedForm = $('#form_forgot_password').serialize();
	// 		if (formBefore != changedForm) {
	// 			$('#form_forgot_password #btnUpd').prop( "disabled", false );
	// 		} else {
	// 			$('#form_forgot_password #btnUpd').prop( "disabled", true );
	// 		}
	// 	});
	// }

	//email check
	// if ( $( '#form_forgot_password #email' ).length ) {
	// 	$(document).on('change', '#email', function (event) {
	// 		event.preventDefault();
	// 		let email = $('#email');
	// 		let EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	//
	// 		if(email.val().trim() == '' || EmailRegex.test(email.val()) == false){
	// 			$('#form_forgot_password #emailerror').css("display", "block");
	// 			$("#form_forgot_password #divEmail").removeClass('u-has-success');
	// 			$("#form_forgot_password #divEmail").addClass('u-has-error');
	// 			$('#form_forgot_password #btnUpd').prop( "disabled", true );
	// 		} else {
	// 			$('#form_forgot_password #emailerror').css("display", "none");
	// 			$("#form_forgot_password #divEmail").removeClass('u-has-error');
	// 			$('#form_forgot_password #btnUpd').prop( "disabled", false );
	// 		}
	// 	});
	// }



	// Modal Response

	let modalResponse       = new bootstrap.Modal(document.getElementById('modalResponse'), {
		keyboard: false,
		backdrop: 'static',
		focus: true
	}); // NB: istanza della modale Bootstrap, non DOM element

	let modalResponseOk   		= $('#modalResponseOk');
	let modalResponseKo   		= $('#modalResponseKo');
	let modalResponseTitle  	= $('#modalResponseTitle');
	let modalResponseText   	= $('#modalResponseText');
	let modalResponseLinks   	= $('#modalResponseLinks');
	let modalResponseLinkEl 	= $('#modalResponseLinks > a');
	let modalResponseButtonEl 	= $('#modalResponseLinks > button');
	let modalResponseCartLinks 	= $('#modalResponseCartLinks');
	let modalHiddenP			= $('#modalHiddenP');
	let modalResponseButtonElhidden= $('#modalResponseButtonElhidden');



	if ($('#form_forgot_password #btnUpd').length){
		$(document).on('click', '#btnUpd', function (event) {
			event.preventDefault();
			let _this = $(this);
			let error = false,
				formObj = _this.parents('form');
			let langsc = $('#langsc').val();
			let ajaxUrl = '/' + langsc + '/forgot_password';

			$.ajax({
				url: ajaxUrl,
				data: JSON.stringify({"form_forgot_password": $('#form_forgot_password').serialize()}),
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				dataType: "json",
				success: function (data, textStatus, jqXHR) {
					console.log(data);
					if (data.success) {
						modalResponseKo.addClass('d-none');
						modalResponseOk.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
					} else {
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
					}
				},
				statusCode: {
					404: function () {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html("page not found");
						modalResponse.show();
					}
				}
			});


		});
	}


	if ($('#form_dp #submit_dp').length){
		$(document).on('click', '#submit_dp', function (event) {
			console.log("click submit_dp");
			event.preventDefault();
			let _this = $(this);
			let error = false,
				formObj = _this.parents('form');

			let langsc = $('#langsc').val();
			let ajaxUrl = '/' + langsc + '/my_personal_update_customer';

			if (error === false) {
				$.ajax({
					url: ajaxUrl,
					data: $('#form_dp').serialize(),/*JSON.stringify({"formDP":$('#form_dp').serialize()}),*/
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);
						if (data.success) {
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("page not found");
							modalResponse.show();
						}
					}
				});
			}

		});
	}


	if ($('#form_restore_password').length){
		let formBefore;
		let $formstatus = $('#form_restore_password :input');
		$('#form_restore_password #btnUpd').prop( "disabled", true );

		$(function() {
			formBefore = $("form").serialize();
		});

		$formstatus.change(function () {
			let changedForm = $('#form_restore_password').serialize();
			if (formBefore != changedForm) {
				$('#form_restore_password #btnUpd').prop( "disabled", false );
			} else {
				$('#form_restore_password #btnUpd').prop( "disabled", true );
			}
		});
	}

	//pw check --------------
	if ( $( '#form_restore_password #NewPassword' ).length ) {
		$(document).on('change', '#NewPassword', function (event) {
			event.preventDefault();
			if ($('#form_restore_password #NewPassword').val() != $('#form_restore_password #ConfirmPassword').val()) {
				$("#form_restore_password #confirmpassword-error").css("display", "block");
				$("#form_restore_password #divConfirmPassword").removeClass('u-has-success');
				$("#form_restore_password #divConfirmPassword").addClass('u-has-error');
			} else {
				$("#form_restore_password #confirmpassword-error").css("display", "none");
				$("#form_restore_password #divConfirmPassword").removeClass('u-has-error');
			}
		});
	}

	if ( $( '#form_restore_password #ConfirmPassword' ).length ) {
		$(document).on('change', '#ConfirmPassword', function (event) {
			event.preventDefault();
			if ($('#form_restore_password #NewPassword').val() != $('#form_restore_password #ConfirmPassword').val()) {
				$("#form_restore_password #confirmpassword-error").css("display", "block");
				$("#form_restore_password #divConfirmPassword").removeClass('u-has-success');
				$("#form_restore_password #divConfirmPassword").addClass('u-has-error');
			} else {
				$("#form_restore_password #confirmpassword-error").css("display", "none");
				$("#form_restore_password #divConfirmPassword").removeClass('u-has-error');
			}
		});
	}

	if ($('#form_restore_password #btnUpd').length){
		$(document).on('click', '#btnUpd', function (event) {
			event.preventDefault();
			let error = false;

			if ($('#form_restore_password #NewPassword').val() == '' || $('#form_restore_password #NewPassword').val() == undefined) {
				error = true;
			}
			if ($('#form_restore_password #ConfirmPassword').val() == '' || $('#form_restore_password #ConfirmPassword').val() == undefined) {
				error = true;
			}

			if (error === false) {
				$("#form_restore_password #confirmpassword-error").css("display", "none");
				$("#form_restore_password #divConfirmPassword").removeClass('u-has-error');
				$("#form_restore_password #divConfirmPassword").addClass('u-has-success');
				$("#form_restore_password #divNewPassword").addClass('u-has-success');

				let langsc = $('#langsc').val();
				let ajaxUrl = '/' + langsc + '/my_personal_update_customer';

				$.ajax({
					url: ajaxUrl,
					data: $('#form_restore_password').serialize(),
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);
						let message2;
						if (data.success) {
							if (data.message2 != undefined) {
								message2 = data.message2
							} else {
								message2 = "Ok";
							}
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("page not found");
							modalResponse.show();
						}
					}
				});
			}


		});
	}

	// Modal

	var modal       = new bootstrap.Modal(document.getElementById('baseModal'), {
		keyboard: false,
		backdrop: 'static',
		focus: true
	});
	var modaltitle  = $('#modal-title');
	var modaltext   = $('#modal-body');


    function submitAJAXForm(_this, event) {
        if (event) {
            event.preventDefault();
        }
        console.log("submitAjaxForm");
        //console.log("Form data:", _this.parents('form').serialize());
//queste 3 successive sono popolate in account.html.twig per il loader in pagina (andrebbero replicati su checkout);
		const loader = document.getElementById('loader') || null;
		let formId = _this.closest('form').attr('id'); // Extract form ID
		$('#'+formId).find('input, select, textarea').each(function () {
			localStorage.setItem(this.name, $(this).val());
		});
		let formObj     = _this.parents( 'form' );
		let actionURL   = formObj.attr( 'action' );
		let redirectVal = formObj.find( '[name="redirectval"]' ).val();//no contact form e form pagina (modale)
		let formData	= new FormData(formObj[0]);

		if( actionURL == '' || actionURL == undefined ) {
			console.log('actionUrl vuota, provo name');
			actionURL   = formObj.find( '[name="action"]' ).val();
			if( actionURL == '' || actionURL == undefined ) {
				console.log('actionUrl ancora vuota, provo id');
				actionURL   = formObj.find( '[name="action"]' ).val();
				if( actionURL == '' || actionURL == undefined ) {
					console.log('actionUrl ancora vuota, provo id');
					actionURL   = formObj.find( '[id="action"]' ).val();
					if( actionURL == '' || actionURL == undefined ) {
						console.log('actionUrl ancora vuota 2, provo id campo hiddend da db');
						actionURL   = formObj.find( '#0-action' ).val();
					}
				}
			}
		}
		formObj.find('input').each(function() {
			console.log('ID:', this.id, 'NAME:', this.name, 'VALUE:', this.value);
		});
		let elem = document.getElementById(formObj[0].id).elements;
		let i = 0
		while( i < elem.length )    {
			if(elem[i].name !== 'action') {
				formData.append(elem[i].name, elem[i].value);
			}
			i++;
		}
		//console.log('action url: ' + actionURL);
		if( actionURL != '' && actionURL != undefined ) {
			//console.log('actionUrl NON vuota');
			/*_this.addClass( 'loading' );*/
			if (loader !== null) {
    			loader.style.display = 'block';
			}
			console.log('invio il form via ajax');
			$.ajax({
				type	: 'POST',
				url		: actionURL,
				data	: formData ? formData : formObj.serialize(),
				/*dataType    : 'json',*/
				cache       : false,
				contentType : false,
				processData : false,
				success: function ( result ) {
					//console.log(result);
					/*_this.removeClass( 'loading' );*/
					formObj.find( 'input[name=action],input[name=g-recaptcha-response],input[name=invoice-required]' ).remove();
					formObj.find( 'input[name=rememberCheckbox]' ).remove();

					if ( typeof ( result ) !== 'undefined' && result !== null ) {
						if (typeof result === 'string' || result instanceof String){
//console.log(result);
							result = $.parseJSON( result );
						}

						formObj.find( 'input[type=text],input[type=email],input[type=tel],input[type=password],textarea' ).each( function () {
							$( this ).val('');
							$( this ).removeClass( 'error' );
						});
						formObj.find( '.g-recaptcha' ).removeClass( 'error' );
						formObj.find( 'input[type=checkbox],input[type=radio]' ).prop( 'checked', false );
						if( formObj.find( '.g-recaptcha' ).length > 0 ) {
							grecaptcha.reset();
						}

						if(result.status || (result.success && result.success != 'error')){
							console.log('form submission ok - no errori');
							window.dataLayer = window.dataLayer || []
							dataLayer.push({
								'event': 'formSubmission',
								'formType': formObj.find( '[name="formname"]' ).val(),
								'formPosition': formObj.find( 'input[name="formposition"]' ).val()
							});
/*console.log(result);
console.log(result.status);//sono vuoti
console.log(result.redirectval);//sono vuoti
console.log(result.message);
alert(result.message);
//return;*/
							if (loader !== null) {
								loader.style.display = 'none';
							}

							if(result.status || (result.success && result.success == 'false')) {
								console.log('form submission ko!!!!');
								/**
								 * per JACOPO: questa parte è scritta espressamente per account.html.twig
								 * andrebbe replicata per il cart sulla modale di salesforce.
								 * Magari standardizzata la modale con stesso id in uscita da tutti i form...
								 * Gli altri elseif ed else non sono stati graficamente gestiti
								 */
								const modalResponse = $('#modalResponse');
								if (modalResponse.length) {
									modalResponse.find('#modalResponseText').text(result.message);
									const modalResponseElement = new bootstrap.Modal(modalResponse);
									modalResponseElement.show();
								}else{
									modalResponseOk.addClass('d-none');
									modalResponseKo.removeClass('d-none');
									modalResponseTitle.removeClass('d-none').html(result.message);
									modalResponse.show();
								}

								/*if(result.cause.length == 0 ) {
									window.location.href = result.redirectval;
								}*/
							}else if(result.success && result.success == true && !result.redirectval){/*contact form e form in pagina*/
								console.log('form submission ok!!!! Undefined case');
								if (loader !== null) {
									loader.style.display = 'none';
								}
								modalResponseKo.addClass('d-none');
								modalResponseOk.removeClass('d-none');
								modalResponseTitle.removeClass('d-none').html(result.message);
								modalResponse.show();

							}else if( result.redirectval !== 'undefined' ){
								if (loader !== null) {
									loader.style.display = 'none';
								}
								window.location.href = result.redirectval;
							}
						}else{
							if (loader !== null) {
								loader.style.display = 'none';
							}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(result.message);
							modalResponse.show();
							$('#'+formId).find('input, select, textarea').each(function() {
								let salvato = localStorage.getItem(this.name);
								if (salvato) $(this).val(salvato);
							});
							window.localStorage.clear();
							if (result.cause) {
								$('#' + result.cause).css('border', '1px solid red');
							}
						}
					}
				}
			});
		}
	}


	$(document).on('click', '.submit:not(#btnUpd, #submit_dp, #modifyAddress, #submit_login)', function (event) {
		console.log("ingresso submit form");
		/*
		viene evitato di entrare in questa funzione nei casi di click su bottoni con id 
		#btnUpd, #submit_dp, #modifyAddress Attenzione: gli ultimi due in realtà necessitano dell'aggiunta della
		classe .submit (al momento assente)	al bottone stesso
		 */
        event.preventDefault();
        console.log("submit clicked");
        console.log("Event target:", event.target);

        let _this = $(this);
		const baseUriValue = _this[0] && _this[0].baseURI ? _this[0].baseURI : '';

		let piva = '';
		if(baseUriValue.includes('checkout_login')) {
			piva = document.getElementById('RegisterPiva')?.value;
		}
    	let loader = document.getElementById('loader') || null;
		const langSc = $('#langsc').val();
		//let checkVatUrl = '/' + langSc + '/checkout_register_piva_check';
		if (loader !== null) {
    			loader.style.display = 'block';
		}

		var error = false,
			captchaFlag = false,
			formObj = _this.parents('form'),
			//emailFormat = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/,
			//emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/,
			telFormat = /[0-9 -()+]{8,}?$/,
			actionURL = formObj.attr('action'),
			grecaptchav3 = _this.attr('data-sitekey') || '';
		var errorMessage = '';
		formObj.find('input[required]').removeClass('error');
		formObj.find('.help-block').text('');

		formObj.find('input[required], textarea[required]').each(function () { //======>.required
			var __this      = $(this),
				fieldVal    = __this.val(),
				fieldValMex = __this.attr('data-validationmessage');
			if (fieldVal == '' || fieldVal == undefined) {
				error = true;
				__this.addClass('error');
				__this.parent().find('.help-block').text(fieldValMex);
				errorMessage = fieldValMex;
			} else if (__this.attr('type') == 'checkbox' && !__this.prop('checked')) {
				error = true;
				__this.addClass(fieldValMex);
				__this.parent().find('.help-block').text(fieldValMex);
				errorMessage = fieldValMex;
			} else if (__this.attr('type') == 'email' && !validateEmail(fieldVal)) {
				error = true;
				__this.addClass(fieldValMex);
				__this.parent().find('.help-block').text('no email!');
				errorMessage = 'no email or invalide email address!';
			} else if (__this.attr('type') == 'tel' && !telFormat.test(fieldVal)) {
				error = true;
				__this.addClass(fieldValMex);
				__this.parent().find('.help-block').text('no tel!');
				errorMessage = 'no tel or invalid tel number!';
			} else if (__this.attr('type') == 'file' && !checkUploadedFileList(__this[0])) {
    			error = true;
				__this.addClass(fieldValMex);
				__this.parent().find('.help-block').text('file format not allowed!');
				errorMessage = 'Formato file non consentito (solo jpg, png, pdf)!';
			}
		});
console.log(error);
		if(!error) {
			console.log('nessun errore sin qui')
			if (formObj.attr('id') === 'register' && document.getElementById('RegisterPrivacy')?.checked == false) {
				if (loader !== null) {
					loader.style.display = 'none';
				}
				modalResponseKo.addClass('d-none');
				modalResponseOk.removeClass('d-none');
				modalResponseTitle.removeClass('d-none').html("Devi accettare la privacy policy per procedere");
				modalResponse.show();
				return;
			}

			// Google reCaptcha Verify
			if (typeof (grecaptcha) !== 'undefined' && grecaptcha !== null) {
				console.log('in recaptcha');
				if (grecaptchav3 != '' && grecaptchav3 != undefined) { // For Version 3
					console.log('recaptcha v3 presente');
					captchaFlag = true;
					formObj.find('input[name=action],input[name=g-recaptcha-response]').remove();
					grecaptcha.ready(function () {
						console.log('recaptcha ready');
						grecaptcha.execute(grecaptchav3, {action: 'form'}).then(function (token) {
							console.log('recaptcha v3 eseguito');
							formObj.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
							formObj.prepend('<input type="hidden" name="action" value="form">');
							console.log('recaptcha v3 caricato');
							console.log(error);
							if (!error) {
								console.log('recaptcha v3 no error');
								console.log('base uri:');
								console.log(baseUriValue);
								if (baseUriValue == '' || baseUriValue == undefined || baseUriValue == null || formObj.attr('id') == 'customer_login') {
									if (loader !== null) {
										loader.style.display = 'none';
									}
									console.log('eseguo il submit x undefined o login');
									submitAJAXForm(_this, event);
									console.log("Form submitted");
								} else if (formObj.attr('id') == 'register') {
									console.log('eseguo il submit x registrazione');
									submitAJAXForm(_this);
									/* Rimosso controllo PIVA per consentire a unit diverse
                                       della stessa azienda di acquistare
                                    $.ajax({
                                        url: checkVatUrl,
                                        dataType: "json",
                                        method: "POST",
                                        data: {
                                            piva: piva,
                                        },
                                        success: function (response) {
                                            if (loader !== null) {loader.style.display = 'none';}
                                            if (response.success && response.success === 'true') {
                                                submitAJAXForm(_this);
                                            } else if (response.success && response.success === 'false') {
                                                modalResponseKo.removeClass('d-none');
                                                modalResponseTitle.removeClass('d-none').html(response.message);
                                                modalResponse.show();
                                            } else if (!response.success) {
                                                modalResponseKo.removeClass('d-none');
                                                modalResponseTitle.removeClass('d-none').html(response.message);
                                                modalResponse.show();
                                            }
                                        },
                                        error: function (xhr, status, error) {
                                            //todo: intercettare errore non sto passando response
                                            if (loader !== null) {loader.style.display = 'none';}
                                            if (xhr.status === 404) {
                                                modalResponseKo.removeClass('d-none');
                                                modalResponseTitle.removeClass('d-none').html("URL non trovato.");
                                                modalResponse.show();
                                            } else {
                                                modalResponseKo.removeClass('d-none');
                                                modalResponseTitle.removeClass('d-none').html('errore generico');
                                                modalResponse.show();
                                            }
                                        }
                                    });*/
								} else {
									if (loader !== null) {
										loader.style.display = 'none';
									}
									console.log('eseguo il submit generico');
									submitAJAXForm(_this, event);
									console.log("Form submitted");
								}
							} else {
								console.log('no recaptcha or error loading it!!!');
							}
						});
					});
				} else {
					console.log('no recaptcha v3!!!');
				}
			} else {
				console.log('no recaptcha!!!');
			}
		}else{
			if (loader !== null) {
				loader.style.display = 'none';
			}
			if (errorMessage.trim() === "E' necessario") {
			  errorMessage = "Compilare tutti i campi necessari";
			}
			modalResponseOk.addClass('d-none');
			modalResponseKo.removeClass('d-none');
			modalResponseTitle.removeClass('d-none').html(errorMessage);
			modalResponse.show();
		}
	});

	function checkUploadedFileList(input) {
		const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
		const files = Array.from(input.files);
		const invalidFiles = files.filter(file => !allowedTypes.includes(file.type));
		if (invalidFiles.length > 0) {
			input.value = '';
			return false;
		}
		return true;
	}



	/* ACCOUNT */

	//TODO: ajax remove form wishlist
	$('#wishlisttable [id^="removeItem-"]').on('click', function (event) {
		event.preventDefault();
		$(this).parent().parent().remove();
	});

	//check if form's been modified. in that case it enables the update button.
	if ($('#form_dp').length){
		let formBefore;
		let $formstatus = $('#form_dp :input');/*, formAltered = false;*/
		$('#form_dp #submit_dp').prop( "disabled", true );

		$(function() {
			formBefore = $("form").serialize();
		});

		$formstatus.change(function () {
			let changedForm = $('#form_dp').serialize();
			if (formBefore != changedForm) {
				/*$("#btnSave").css('background-color', 'green');*/
				$('#form_dp #submit_dp').prop( "disabled", false );
			} else {
				$('#form_dp #submit_dp').prop( "disabled", true );
			}
		});
	}


    /**
     * my_personal_update_customer
     */
	if ($('#form_dp #submit_dp').length){
		$(document).on('click', '#submit_dp', function (event) {
			event.preventDefault();
			let _this = $(this);
			let error = false,
				formObj = _this.parents('form');

			if (typeof ($('#newsletterCheckbox')[0]) !== 'undefined') {
				let newsletterCheckbox = ($('#newsletterCheckbox')[0].checked ? 'on' : 'off');
				formObj.prepend('<input type="hidden" name="newsletterCheckbox" value="' + newsletterCheckbox + '">');
			}

			if ($('#form_dp #firstName').val() == '' || $('#form_dp #firstName').val() == undefined) {
				error = true;
			}
			if ($('#form_dp #lastName').val() == '' || $('#form_dp #lastName').val() == undefined) {
				error = true;
			}

			let langsc = $('#langsc').val();
			let ajaxUrl = '/' + langsc + '/my_personal_update_customer';

			if (error === false) {
				$.ajax({
					url: ajaxUrl,
					data: $('#form_dp').serialize(),/*JSON.stringify({"formDP":$('#form_dp').serialize()}),*/
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);
						if (data.success) {
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("not found");
							modalResponse.show();
						}
					}
				});
			}

		});
	}

    /**
     * my_address_update
     */
	if ( $( '#updateAddress' ).length ) {
		$(document).on('click', '#updateAddress', function (event) {
			event.preventDefault();

			let _this = $(this);
			let error = false,
				captchaFlag = false,
				formObj     = _this.parents('form'),
				//emailFormat = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
				//emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/,
				telFormat   = /[0-9 -()+]{8,}?$/,
				actionURL   = formObj.attr('action'),
				idForm      = _this.attr('id') || '',
				errorIdField = '',
				errorField = '';
			formObj.find('.required').removeClass('error');
			formObj.find('.help-block').text('');
			/*alert(formObj.attr('id'));*/

			formObj.find('input').each(function(){
				if($(this).prop('required')) {//check of required fields
					let __this = $(this),
						fieldVal = __this.val();
					if (fieldVal == '' || fieldVal == undefined) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'email' && !validateEmail(fieldVal)) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'tel' && !telFormat.test(fieldVal)) {
						error = true;
						__this.addClass('error');
					}
				}
			});


			if (error === false) {
				let langsc = $('#langsc').val();
				let ajaxUrl = '/' + langsc + '/my_address_update';

				$.ajax({
					url: ajaxUrl,
					data: JSON.stringify({"updateAddress": formObj.serialize()}),
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);
						if (data.success) {
							Swal.fire({
								/*text: $('<div>').html(data.message).text(),  // for encoding html entities*/
								html: '<b>' + data.message + '</b><br>',
								icon: 'success',
								showCancelButton: false,
								confirmButtonText: "Ok",
								confirmButtonColor: '#0D4DA1'
							}).then(function () {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("not found");
							modalResponse.show();
						}
					}
				});
			}else{
				if ($('#errormsg').length > 0) {
					Swal.fire({
						title: 'Error',
						html: '<b>' + $('#errormsg').val() + '</b><br>',
						icon: 'warning',
						showCancelButton: false,
						confirmButtonText: "Ok",
						confirmButtonColor: '#0D4DA1'
					});
				}
			}

		});
	};

    /**
     * my_personal_update_customer
     */
	if ($('#form_p #submit_p').length) {
		$(document).on('click', '#submit_p', function (event) {
			event.preventDefault();
			let error = false;


			if ($('#form_p #RegisterPassword').val() == '' || $('#form_p #RegisterPassword').val() == undefined) {
				error = true;
				$("#form_p #divRegisterPassword").removeClass('u-has-success');
				$("#form_p #divRegisterPassword").addClass('u-has-error');
			}
			if ($('#form_p #NewPassword').val() == '' || $('#form_p #NewPassword').val() == undefined) {
				error = true;
				$("#form_p #divNewPassword").removeClass('u-has-success');
				$("#form_p #divNewPassword").addClass('u-has-error');
			}
			if ($('#form_p #ConfirmPassword').val() == '' || $('#form_p #ConfirmPassword').val() == undefined) {
				error = true;
				$("#form_p #divConfirmPassword").removeClass('u-has-success');
				$("#form_p #divConfirmPassword").addClass('u-has-error');
			}
			if ($('#form_p #RegisterPassword').val() == $('#form_p #NewPassword').val()) {
				error = true;
				$("#form_p #newpassword-error").css("display", "block");
				$("#form_p #divNewPassword").removeClass('u-has-success');
				$("#form_p #divNewPassword").addClass('u-has-error');
			}
			if ($('#form_p #NewPassword').val() != $('#form_p #ConfirmPassword').val()) {
				error = true;
				$("#form_p #confirmpassword-error").css("display", "block");
				$("#form_p #divConfirmPassword").removeClass('u-has-success');
				$("#form_p #divConfirmPassword").addClass('u-has-error');
			}

			if (error === false) {
				$("#form_p #divRegisterPassword").removeClass('u-has-error');
				$("#form_p #newpassword-error").css("display", "none");
				$("#form_p #divNewPassword").removeClass('u-has-error');
				$("#form_p #confirmpassword-error").css("display", "none");
				$("#form_p #divConfirmPassword").removeClass('u-has-error');

				let langsc = $('#langsc').val();
				let ajaxUrl = '/' + langsc + '/my_personal_update_customer';

				$.ajax({
					url: ajaxUrl,
					data: JSON.stringify({"formP": $('#form_p').serialize()}),
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);

						if (data.success) {
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("not found");
							modalResponse.show();
						}
					}
				});
			}

		});
	}

    /**
     * my_address_update
     */
	if ( $('#form_p #NewPassword').length ) {
		$(document).on('change', '#NewPassword', function (event) {
			event.preventDefault();
			if ($('#form_p #RegisterPassword').val() == $('#form_p #NewPassword').val()) {
				$("#form_p #newpassword-error").css("display", "block");
				$("#form_p #divNewPassword").removeClass('u-has-success');
				$("#form_p #divNewPassword").addClass('u-has-error');
			} else {
				$("#form_p #newpassword-error").css("display", "none");
				$("#form_p #divNewPassword").removeClass('u-has-error');
			}

			if ($('#form_p #NewPassword').val() != $('#form_p #ConfirmPassword').val()) {
				$("#form_p #confirmpassword-error").css("display", "block");
				$("#form_p #divConfirmPassword").removeClass('u-has-success');
				$("#form_p #divConfirmPassword").addClass('u-has-error');
			} else {
				$("#form_p #confirmpassword-error").css("display", "none");
				$("#form_p #divConfirmPassword").removeClass('u-has-error');
			}
		});
	}

	if ( $( '#form_p #ConfirmPassword' ).length ) {
		$(document).on('change', '#ConfirmPassword', function (event) {
			event.preventDefault();
			if ($('#form_p #NewPassword').val() != $('#form_p #ConfirmPassword').val()) {
				$("#form_p #confirmpassword-error").css("display", "block");
				$("#form_p #divConfirmPassword").removeClass('u-has-success');
				$("#form_p #divConfirmPassword").addClass('u-has-error');
			} else {
				$("#form_p #confirmpassword-error").css("display", "none");
				$("#form_p #divConfirmPassword").removeClass('u-has-error');
			}
		});
	}

	if ( $( '#form_p #RegisterPassword' ).length ) {
		$(document).on('change', '#RegisterPassword', function (event) {
			event.preventDefault();
			if ($('#form_p #RegisterPassword').val() == $('#form_p #NewPassword').val()) {
				$("#form_p #newpassword-error").css("display", "block");
				$("#form_p #divNewPassword").removeClass('u-has-success');
				$("#form_p #divNewPassword").addClass('u-has-error');
			} else {
				$("#form_p #newpassword-error").css("display", "none");
				$("#form_p #divNewPassword").removeClass('u-has-error');
			}
		});
	}

    /**
     * my_address_update
     */
	if ( $( '#modifyAddress' ).length ) {
		$(document).on('click', '#modifyAddress', function (event) {
			event.preventDefault();

			let _this = $(this);
			let error       = false,
				captchaFlag = false,
				formObj             = _this.parents('form'),
				//emailFormat = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
				//emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/,
				telFormat   = /[0-9 -()+]{8,}?$/,
				actionURL           = formObj.attr('action'),
				idForm              = _this.attr('id') || '',
				errorIdField = '',
				errorField  = '';
			formObj.find('.required').removeClass('error');
			formObj.find('.help-block').text('');
			/*alert(formObj.attr('id'));*/

			formObj.find('input').each(function(){
				if($(this).prop('required')) {//check of required fields
					let __this = $(this),
						fieldVal = __this.val();
					if (fieldVal == '' || fieldVal == undefined) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'email' && !validateEmail(fieldVal)) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'tel' && !telFormat.test(fieldVal)) {
						error = true;
						__this.addClass('error');
					}
				}
			});


			if (error === false) {
				let langsc = $('#langsc').val();
				let ajaxUrl = '/' + langsc + '/my_address_update';

				$.ajax({
					url: ajaxUrl,
					data: JSON.stringify({"updateAddress": formObj.serialize()}),
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);

						if (data.success) {
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("not found");
							modalResponse.show();
						}
					}
				});
			}else{
				if ($('#errormsg').length > 0) {
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html($('#errormsg').val());
					modalResponse.show();
				}
			}

		});
	};

	if ( $( '#deleteAddress' ).length ) {
		$(document).on('click', '#deleteAddress', function (event) {
			event.preventDefault();

			let _this = $(this);
			let error = false,
				captchaFlag = false,
				formObj     = _this.parents('form'),
				actionURL   = formObj.attr('action');

			let langsc = $('#langsc').val();
			let ajaxUrl = '/' + langsc + '/my_address_delete';

			$.ajax({
				url: ajaxUrl,
				data: JSON.stringify({"deleteAddress": formObj.serialize()}),
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				dataType: "json",
				success: function (data, textStatus, jqXHR) {
					console.log(data);

					if (data.success) {
						modalResponseKo.addClass('d-none');
						modalResponseOk.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
						document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
							window.location.href = data.redirectval;
						});
					} else {
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
					}
				},
				statusCode: {
					404: function () {
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html("not found");
						modalResponse.show();
					}
				}
			});
		});
	};

	if ( $( '#addAddress' ).length ) {
		$(document).on('click', '#addAddress', function (event) {
			event.preventDefault();
			let _this = $(this);
			let error = false,
				captchaFlag = false,
				formObj     = _this.parents('form'),
				//emailFormat = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
				//emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/,
				telFormat   = /[0-9 -()+]{8,}?$/,
				actionURL   = formObj.attr('action'),
				idForm      = _this.attr('id') || '',
				errorIdField = '',
				errorField = '';
			formObj.find('.required').removeClass('error');
			formObj.find('.help-block').text('');
			/*alert(formObj.attr('id'));*/

			formObj.find('input').each(function(){
				if($(this).prop('required')) {//check of required fields
					let __this = $(this),
						fieldVal = __this.val();
					if (fieldVal == '' || fieldVal == undefined) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'email' && !validateEmail(fieldVal)) {
						error = true;
						__this.addClass('error');
					} else if (__this.attr('type') == 'tel' && !telFormat.test(fieldVal)) {
						error = true;
						__this.addClass('error');
					}
				}
			});


			if (error === false) {
				let langsc = $('#langsc').val();
				let ajaxUrl = '/' + langsc + '/my_address_add';

				$.ajax({
					url: ajaxUrl,
					data: JSON.stringify({"addAddress": formObj.serialize()}),
					cache: false,
					contentType: false,
					processData: false,
					type: 'POST',
					dataType: "json",
					success: function (data, textStatus, jqXHR) {
						console.log(data);

						if (data.success) {
							modalResponseKo.addClass('d-none');
							modalResponseOk.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
								window.location.href = data.redirectval;
							});
						} else {
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}
					},
					statusCode: {
						404: function () {
							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html("page not found");
							modalResponse.show();
						}
					}
				});
			}else{
				if ($('#errormsg').length > 0) {
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html('<b>' + $('#errormsg').val() + '</b><br>');
					modalResponse.show();
				}
			}

		});
	};
	/* FINE ACCOUNT */


	/* CHECKOUT SHIPPING inizio */
	$('#state').on('click change paste keyup',function() {
		$('#countrySelected').val($('#state').val());
		const countrySelected = document.querySelector('#countrySelected');
		if (countrySelected.value === 'IT') {
			$('input.administrativearea').attr('hidden', '');
			$('div.administrativearea').removeAttr('hidden');
		} else {
			console.log(countrySelected.value);
			$('div.administrativearea').attr('hidden', '');
			$('input.administrativearea').removeAttr('hidden');
		}
	});

	$('#administrativeareaInput').on('click change paste keyup',function() {
		$('#administrativearea').val($('#administrativeareaInput').val());
	});

	$('#administrativeareaSelect').on('click change paste keyup',function() {
		$('#administrativearea').val($('#administrativeareaSelect').val());
	});

	if($('#administrativeareaSelect').val() != ''){
		$('#administrativearea').val($('#administrativeareaSelect').val());
	}

	//Funzione per l'aggiornamento dell'indirizzo di Spedizione dalla selezione nella Select
	$('#savedAddressShipping').on('change',function() {
		var idAddressSelected = $('#savedAddressShipping option:selected')[0].value;
		var addressOnDB = $('#addressImported')[0].value;
		var jsonAddress = jQuery.parseJSON(addressOnDB);
		if(jsonAddress != null){
			//Aggiorno i Campi nel Form dell'indirizzo
			if(idAddressSelected){
				$('#idshippingaddress')[0].value = idAddressSelected;
				$('#firstName')[0].value = jsonAddress[idAddressSelected].firstName;
				$('#lastName')[0].value = jsonAddress[idAddressSelected].lastName;
				$('#companyName')[0].value = jsonAddress[idAddressSelected].company;
				$('#street')[0].value = jsonAddress[idAddressSelected].street;
				$('#housenumber')[0].value = jsonAddress[idAddressSelected].housenumber;
				$('#cityAddress')[0].value = jsonAddress[idAddressSelected].cityAddress;
				$('#postcode')[0].value = jsonAddress[idAddressSelected].postcode;
				$('#administrativearea')[0].value = jsonAddress[idAddressSelected].administrativearea;
				$('#state')[0].value = jsonAddress[idAddressSelected].countrycode;
				$('#emailAddress')[0].value = jsonAddress[idAddressSelected].emailAddress;
				$('#phone')[0].value = jsonAddress[idAddressSelected].phone;
			}
		}
	});

	//Funzione per l'aggiornamento dell'indirizzo di Fatturazione dalla selezione nella Select
	$('#savedAddressBilling').on('change',function() {
		var idAddressSelected = $('#savedAddressBilling option:selected')[0].value;
		var addressOnDB = $('#billingImported')[0].value;
		var jsonAddress = jQuery.parseJSON(addressOnDB);
		if(jsonAddress != null) {
			//Aggiorno i Campi nel Form dell'indirizzo
			if(idAddressSelected) {
				$('#idbillingaddress')[0].value = idAddressSelected;
				$('#billingfirstName')[0].value = jsonAddress[idAddressSelected].firstName;
				$('#billinglastName')[0].value = jsonAddress[idAddressSelected].lastName;
				$('#billingcompanyName')[0].value = jsonAddress[idAddressSelected].company;
				$('#billingstreetAddress')[0].value = jsonAddress[idAddressSelected].street;
				$('#billinghousenumber')[0].value = jsonAddress[idAddressSelected].housenumber;
				$('#billingcityAddress')[0].value = jsonAddress[idAddressSelected].cityAddress;
				$('#billingpostcode')[0].value = jsonAddress[idAddressSelected].postcode;
				$('#billingadministrativearea')[0].value = jsonAddress[idAddressSelected].administrativearea;
				$('#billingstate')[0].value = jsonAddress[idAddressSelected].countrycode;
				$('#pec')[0].value = jsonAddress[idAddressSelected].emailAddress;
				$('#billingphone')[0].value = jsonAddress[idAddressSelected].phone;
				$('#vatnumber')[0].value = jsonAddress[idAddressSelected].vat;
				$('#sdi')[0].value = jsonAddress[idAddressSelected].sdi;
			}
		}
	});

	// Billing different from shipping in checkout_shipping

	function showBilling() {
		$('#content').find( '#viscoladdress' ).removeClass( 'col-md-6 offset-md-3' ).addClass('col-md-5 ml-xl-auto mr-md-auto mr-xl-0');
		$('form').find( '#viscol' ).removeClass( 'col-md-6 offset-md-3' ).addClass('col-md-5 ml-xl-auto mr-md-auto mr-xl-0 mb-8 mb-md-0');
		$('#content').find( '#hiddcol1address' ).removeClass( 'd-none' ).addClass('col-md-1 d-none d-md-block');
		$('form').find( '#hiddcol1' ).removeClass( 'd-none' ).addClass('col-md-1 d-none d-md-block');
		$('#content').find( '#hiddcol2address' ).removeClass( 'd-none' ).addClass('col-md-5 ml-md-auto ml-xl-0 mr-xl-auto');
		$('form').find( '#hiddcol2' ).removeClass( 'd-none' ).addClass('col-md-5 ml-md-auto ml-xl-0 mr-xl-auto');
		$('#hiddcol2').find( '*[data-required]' ).each( function() {
			var ___this = $( this );
			___this.prop('required',true);
		});
	}
	function hideBilling() {
		$('#content').find( '#viscoladdress' ).removeClass( 'col-md-5 ml-xl-auto mr-md-auto mr-xl-0' ).addClass('col-md-6 offset-md-3');
		$('form').find( '#viscol' ).removeClass( 'col-md-5 ml-xl-auto mr-md-auto mr-xl-0 mb-8 mb-md-0' ).addClass('col-md-6 offset-md-3');
		$('#content').find( '#hiddcol1address' ).removeClass('col-md-1 d-none d-md-block').addClass('d-none');
		$('form').find( '#hiddcol1' ).removeClass('col-md-1 d-none d-md-block').addClass('d-none');
		$('#content').find( '#hiddcol2address' ).removeClass('col-md-5 ml-md-auto ml-xl-0 mr-xl-auto').addClass('d-none');
		$('form').find( '#hiddcol2' ).removeClass('col-md-5 ml-md-auto ml-xl-0 mr-xl-auto').addClass('d-none');
		$('#hiddcol2').find( '*[data-required]' ).each( function() {
			var ___this = $( this );
			___this.prop('required',false);
		});
	}

	setTimeout(function() {
		if($('#differentShipping').is(':checked')) {
			showBilling();
		} else {
			hideBilling();
		}
	}, 500);

	$('#differentShipping').on( 'click', function() {
		if($(this).is(':checked')) {
			showBilling();
		} else {
			hideBilling();
		}
	})


	function writeLogJS(level, message, ending = 0) {
		// Costruisci payload
		const data = {
			level: level,
			message: message,
			ending: ending,
			timestamp: new Date().toISOString()
		};
		
		// Chiamata fetch all'endpoint PHP
		fetch('/src/app/log_writer.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).catch(error => {
			console.error('Errore nel logging:', error);
		});
	}

    function validateEmail(email) {
        console.log("inizio validazione email " + email);
        let isValid = false;
        $.ajax({
            type: 'POST',
            url: '/api/services/validateemail',
            data: { email: email },
            dataType: 'json',
            async: false,
            /*todo: implementare gestione messaggi errore da service*/
            success: function(response) {
                isValid = response.success;
            },
            error: function() {
                isValid = false;
            }
        });
        console.log("fine validazione email " + isValid);
        return isValid;
    }

	function parseForm(_this){
		writeLogJS('INFO', '=== Ingresso in parseForm ===');
		let spinner = $('#loader');
		let error       = false,
			captchaFlag = false,
			formObj             = _this.parents( 'form' ),
			requirebilling = '',
			rememberMe  = '',
			// REGEX EMAIL VECCHIA: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/
			//emailFormat = /^(([\w%+-]([.]?))+[\w%+-])+@[\w.-]+\.[a-zA-Z]{2,4}?$/,
            //emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/
            //emailFormat = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/,
			telFormat   = /[0-9 -()+]{8,}?$/,
			actionURL           = formObj.attr( 'action' ),
			grecaptchav3        = _this.attr( 'data-sitekey' ) || '',
			errorIdField = '',
			errorField  = '',
			nameError   = '',
			divError    = '',
			phoneError= false;

		//formObj.find( '.required' ).removeClass( 'error' );
		formObj.find( '.help-block' ).text( '' );

		/*formObj.find( '.required' ).each( function() {*/
		formObj.find('input').each(function(){
			if($(this).prop('required')) {//check of required fields
				var __this = $(this),
					fieldVal = __this.val();
				__this.removeClass( 'error' );
				nameError = __this.attr('name') + '-error';
				divError  = $('[id="'+ nameError + '"]');
				divError.prop('hidden', true);

 			if (fieldVal == '' || fieldVal == undefined) {
                    console.log('fieldVal == "" || fieldVal == undefined');
                    console.log('required field error on:');
                    console.log(__this);
                    writeLogJS('ERROR', 'required field error on: ' + JSON.stringify({name: __this.attr('name'), type: __this.attr('type'), id: __this.attr('id')}));
					error = true;
					__this.addClass('error');
					divError.prop('hidden', false);
 			} else if (__this.attr('type') == 'email' && !validateEmail(fieldVal)) {
                    console.log('email error');
                    writeLogJS('ERROR', 'email error - Invalid email format: ' + fieldVal);
					error = true;
					__this.addClass('error');
					divError.prop('hidden', false);
 			} else if (__this.attr('type') == 'tel' && !telFormat.test(fieldVal)) {
					console.log("Phone or Business Phone error");
					writeLogJS('ERROR', 'Phone or Business Phone error - Invalid format: ' + fieldVal);
					error = true; phoneError = true;
					__this.addClass('error');
					divError.prop('hidden', false);
				}
			}
		});


		if(typeof ($('#differentShipping')[0]) !== 'undefined') {
			requirebilling = ($('#differentShipping')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="invoice-required" value="' + requirebilling + '">');
		}
		if(typeof ($('#rememberCheckbox')[0]) !== 'undefined') {
			rememberMe = ($('#rememberCheckbox')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="rememberCheckbox" value="' + rememberMe + '">');
		}
		if(typeof ($('#rememberCheckboxReg')[0]) !== 'undefined') {
			rememberMe = ($('#rememberCheckboxReg')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="rememberCheckboxReg" value="' + rememberMe + '">');
		}

		// Google reCaptcha Verify
		if ( typeof ( grecaptcha ) !== 'undefined' && grecaptcha !== null ) {
			if( formObj.find( '.g-recaptcha' ).length > 0 ) { // For Version 2
				var gResponse = grecaptcha.getResponse();
 			if ( ! ( gResponse.length ) ) {
					error = true;
					formObj.find( '.g-recaptcha' ).addClass( 'error' );
                    console.log('captcha error');
                    writeLogJS('ERROR', 'captcha error - reCAPTCHA validation failed');
				}
			} else if( grecaptchav3 != '' && grecaptchav3 != undefined ) { // For Version 3
				captchaFlag = true;
				formObj.find( 'input[name=action],input[name=g-recaptcha-response]' ).remove();
				grecaptcha.ready(function() {
					grecaptcha.execute( grecaptchav3, { action: 'form' } ).then( function( token ) {
						formObj.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
						formObj.prepend('<input type="hidden" name="action" value="form">');

						if( ! error ) {
							spinner.show();
							submitAJAXForm( _this );
						} else{
 						if ($('#errormsg').length > 0) {
								let errMessage = $('#errormsg').val();//generic
								if(phoneError==true){
                                    console.log('phone error');
                                    writeLogJS('WARNING', 'phone error - Displaying phone error message');
									errMessage = $('#phoneerrormsg').val();//err in phone number
								}
                                console.log(errMessage);
                                writeLogJS('INFO', 'Error message displayed: ' + errMessage);
								if (loader !== null) {    loader.style.display = 'none';}
								modalResponseOk.addClass('d-none');
								modalResponseKo.removeClass('d-none');
								modalResponseTitle.removeClass('d-none').html(errMessage);
								modalResponse.show();
								if (spinner.is(':visible')) {
								  spinner.hide();
								}
							}
						}
					});
				});
			}
		}
		writeLogJS('INFO', '=== Uscita da parseForm ===', 1);
	}

	$(document).on( 'click', '.submitCheckout', function(event){
console.log("submit Form");
		event.preventDefault();
		console.log($('#state').data('error'));
		let msg_err = ''; let error = false;
		/* required fields */
		if($('#firstName').val() ==''){
			error = true;
			msg_err = $('#firstName').data('msg');
		}
		if($('#lastName').val() ==''){
			error = true;
			msg_err = $('#lastName').data('msg');
		}
		if($('#street').val() ==''){
			error = true;
			msg_err = $('#street').data('msg');
		}
		if($('#cityAddress').val() ==''){
			error = true;
			msg_err = $('#cityAddress').data('msg');
		}
		if($('#cityAddress').val() ==''){
			error = true;
			msg_err = $('#cityAddress').data('msg');
		}
		if($('#housenumber').val() ==''){
			error = true;
			msg_err = $('#housenumber').data('msg');
		}

		if($('#administrativearea').val() === 0 || $('#administrativearea').val() ==''){
			error = true;
			msg_err = $('#administrativearea').data('msg');
		}
		if($('#state').val() === 0 || $('#state').val() ==''){
			error = true;
			msg_err = $('#state').data('msg');
		}
		if($('#emailAddress').val() ==''){
			error = true;
			msg_err = $('#emailAddress').data('msg');
		}
		if($('#phone').val() === 0 || $('#phone').val() ==''){
			error = true;
			msg_err = $('#phone').data('msg');
		}

		if(error === false){
			const _this       = $( this );
			parseForm(_this);
		} else {
			if (loader !== null) {    loader.style.display = 'none';}
			modalResponseOk.addClass('d-none');
			modalResponseKo.removeClass('d-none');
			modalResponseTitle.removeClass('d-none').html(msg_err);
			modalResponse.show();
		}
	});

	$('.billingchange').on('change paste keyup',function(){
		$('#idbillingaddress').val('');
	});

	$( document ).on( 'click', '.submit_guest', function() {
		event.preventDefault();
		let spinner = $('#loader');
		let _this       = $( this ),
			formObj     = _this.parents( 'form' ),
			actionURL   = formObj.attr( 'action' ),
			redirectVal = formObj.find( '[name="redirectval"]' ).val();
		formObj.find('[name="guest_action"]').val('checkout_without_user');

		if(typeof ($('#acceptedTerms')[0]) !== 'undefined') {
			acceptedTerms = ($('#acceptedTerms')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="accepted-privacy" value="' + acceptedTerms + '">');
		}
		if(typeof ($('#newsletterSubscription')[0]) !== 'undefined') {
			newsletterSubscription = ($('#newsletterSubscription')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="newsletter-subscription" value="' + newsletterSubscription + '">');
		}

		spinner.show();
		$.ajax({
			type    : 'POST',
			url     : actionURL,
			data    : formObj.serialize(),
			dataType: 'json',
			success: function (data) {
				var result = null;
				if (typeof data === 'string' || data instanceof String) {
					result = JSON.parse(data);
				}else{
					result = data;
				}
				formObj.find( 'input[name=newsletter-subscription],input[name=accepted-privacy]').remove();

				spinner.hide();
				if(result.success) {
					if(result.type == 'externalpayment'){
						window.location.href = result.message;
					}else{
						window.location.href = result.redirectval;
					}
				}else{
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html(result.message);
					modalResponse.show();
				}
			}
		});
	});
	/* CHECKOUT SHIPPING fine */

	/* CART inizio */
	$( document ).on( 'click', '.submitCart', function() {
		event.preventDefault();

		let spinner = $('#loader');
		let _this       = $( this ),
			formObj     = _this.parents( 'form' ),
			actionURL   = formObj.attr( 'action' ),
			redirectVal = formObj.find( '[name="redirectval"]' ).val();
		let lang_shortcode  = $('#lang-shortcode').val();

		if(typeof ($('#acceptedTerms')[0]) !== 'undefined') {
			acceptedTerms = ($('#acceptedTerms')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="accepted-privacy" value="' + acceptedTerms + '">');
		}
		if(typeof ($('#newsletterSubscription')[0]) !== 'undefined') {
			newsletterSubscription = ($('#newsletterSubscription')[0].checked?'on':'off');
			formObj.prepend('<input type="hidden" name="newsletter-subscription" value="' + newsletterSubscription + '">');
		}

		if($('input[name="paymentMethodRadio"]:checked', '#submitorder').val() == '4' && $('#acceptedTerms')[0].checked == true){//paypal
			/*let form = document.querySelector('#paypal-form');
			let pptkn = document.getElementById('#paypal-at');
			//console.log(form);*/
			let o ;
			//generare token
			spinner.show();
			/*paypalButtons(pptkn,formObj);
            spinner.hide();
            $('#paypal-modal').modal('show');*/
			$.ajax({
				type    : 'POST',
				url     : '/' + lang_shortcode + '/request_paypal_at',
				data    : formObj.serialize(),
				dataType: 'json',
				success: function (data) {
					let result = null;
					if (typeof data === 'string' || data instanceof String) {
						result = JSON.parse(data);
					}else{
						result = data;
					}

					spinner.hide();
					if(result.success) {
						/*$('#paypal_at').value = result.message;*/
						loadPostJS(result.message,formObj);
						$('#paypal-modal').modal('show');
					}else {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(result.message);
						modalResponse.show();
					}
				}
			});
		} else{//altri metodi di pagamento
			spinner.show();
			$.ajax({
				type    : 'POST',
				url     : actionURL,
				data    : formObj.serialize(),
				dataType: 'json',
				success: function (data) {
console.log(data);
					let result = null;
					if (typeof data === 'string' || data instanceof String) {
						result = JSON.parse(data);
					}else{
						result = data;
					}
					formObj.find( 'input[name=newsletter-subscription],input[name=accepted-privacy]').remove();

					spinner.hide();
					if(result.success) {
console.log(result.success);
console.log(result.message);
console.log(result.redirectval);
console.log(result.type);
						if(result.type == 'externalpayment'){
							window.location.href = result.message;
						}else{
							window.location.href = result.redirectval;
						}
					}else {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(result.message);
						modalResponse.show();
					}
				}
			});
		}

	});

	$('[id^="removeItem-"]').on('click',function(event){
		event.preventDefault();
		let _this = $(this),
			idCart = _this.data('cartid'),
			productId = _this.data('productid'),
			couponId = _this.data('couponid'),
			removeId = _this.attr('id');

		let langsc = $('#lngshrtcd').val();
		let ajaxUrl = '/' + langsc + '/remove_from_cart';
		let prevQty  = $(document.getElementById('cart-quantity')).text();
		//console.log(prevQty);
		let prevItemAmount  = $(document.getElementsByName('prevamount-'+productId)).val();//prev counter
		if(typeof prevItemAmount === 'undefined'){
			prevItemAmount = 0;
		}
		//console.log(prevItemAmount);
		let cartQty = parseInt(prevQty) - parseInt(prevItemAmount);
		//console.log(cartQty);
		$.ajax({
			type        : 'POST',
			url         : ajaxUrl,
			data        : JSON.stringify({"idproduct":productId,"idcart":idCart,"idcoupon":couponId}),
			cache       : false,
			contentType : false,
			processData : false,
			dataType    : "json",
			success: function (data) {

				let result = null;
				if (typeof data === 'string' || data instanceof String) {
					result = JSON.parse(data);
				}else{
					result = data;
				}

				if(result.success) {
					alert(result.message);
					//skip di tutto quel che facevamo prima perchè non vengono identificati gli span in nessun modo per cui reload del cart
					window.location.href ='/' + langsc + '/view_cart';
					/*todo: x Jacopo: risistemare html e inserire stringa avviso rimozione (qui cablato) */
					/*todo: se non si risolve in altro modo, eliminare tutta la sezione commentata sottostante */
					/*$('#'+removeId).closest('tr').html("<td>"+$("#name-"+productId+"").html()+"</td><td>è stato rimosso</td>");

					//_this.parent().parent().remove();
					if(result.extraCoupRemove > 0){
						let coup = result.extraCoupRemove;
						document.querySelector('[data-couponid="'+coup+'"]').closest('td').closest('tr').remove();
					}

					//bag counter:
					$(document.getElementById('cart-quantity')).text(cartQty);

					//cart totals:
					var subtotal = parseFloat('0.00').toFixed(2);
console.log(subtotal);

					var elItemPrice = 0;
					var elId = 0;
					document.addEventListener("DOMContentLoaded", () => {
						console.log(document.querySelectorAll('span[id^="price-"]'));
					});
					//$('span[id^="price-"]').each(function(el){
					document.querySelectorAll('span[id^="price-"]').forEach(span => {
						console.log(`ID: ${span.id}, Testo: ${span.textContent.trim()}`);
						/!*console.log(span.textContent.trim());
						//elId        = $(this).attr('id').split('-')[1];//item's Id
						elId		= span.id.split('-')[1];
console.log(elId);
						//elItemPrice = $( this ).text().split(' ')[0]; //item's price
						elItemPrice = span.textContent.trim().split(' ')[0]; //item's price
console.log(elItemPrice);
						elItemPrice =  elItemPrice.replace('.','');
console.log(elItemPrice);
						elItemPrice = parseFloat(elItemPrice.replace(',','.')).toFixed(2);
console.log(elItemPrice);
//alert(elItemPrice);
						var elrelativeCount = document.getElementsByName('products['+elId+']amount');
						var elitemAmount    = parseInt($(elrelativeCount).val());//counter
						subtotal = (+subtotal) + (+parseFloat(elitemAmount * elItemPrice).toFixed(2));
						console.log([elId,elItemPrice,elitemAmount,subtotal]);
						//console.log(new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(subtotal));*!/
					});
console.log("fermo!");
					//cart subtotal
					$(document.getElementById('subtotal')).text(function () {
						return $(this).text().replace($(document.getElementById('subtotal')).text().split(' ')[0], new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(subtotal));
					});

					//cart total
					$(document.getElementById('cartamount')).text(function () {
						return $(this).text().replace($(document.getElementById('cartamount')).text().split(' ')[0], new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(subtotal));
					});
					if(subtotal == 0){
						alert("subtotal vuoto");
						printEmptyCart();
					}*/
				}else {
console.log("ko da php");
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html(result.message);
					modalResponse.show();
				}
			}
		});
	});

	$('#shippingMethodRadio_1').change(function(){
		if($(this)[0].checked) {
			$('#paymentMethodRadio_1').prop('checked', true);
		}
	});

	$('input[name=shippingMethodRadio]').on('change',function (){
		let selectedprice = $('input[name=shippingMethodRadio]:checked', '#submitorder').data('price');
		$('#shippinpricetable').data('price',selectedprice);
		$('#shippinpricetable')[0].textContent = selectedprice;
	})

	if($('input[name=shippingMethodRadio]') !== 'undefined' && $('input[name=shippingMethodRadio]').length > 0){
		let selectedPrice = $('input[name=shippingMethodRadio]:checked', '#submitorder').data('price');
		$('#shippinpricetable').data('price',selectedPrice);
		$('#shippinpricetable')[0].textContent = selectedPrice;

		let currentTotal = $('#ordertotal').data('ordertotal');
		currentTotal = (parseFloat(currentTotal.replace(",", "."))+parseFloat(selectedPrice )).toFixed(2);

		$('#ordertotal').data('price',currentTotal);
		$('#ordertotal')[0].textContent = currentTotal;
	}

	$('input[name=paymentMethodRadio]').on('change',function (){
		let selectedPriceS = $('input[name=shippingMethodRadio]:checked', '#submitorder').data('price');
		if(typeof selectedPriceS == 'undefined'){
			selectedPriceS = 0;
		}
		$('#shippinpricetable').data('price',selectedPriceS);
		$('#shippinpricetable')[0].textContent = selectedPriceS;

		let selectedPriceP = 0;
		if($('input[name=paymentMethodRadio]:checked', '#submitorder').data('price') > 0) {
			selectedPriceP = $('input[name=paymentMethodRadio]:checked', '#submitorder').data('price');
		}

		let currentTotal = $('#ordertotal').data('ordertotal');
		currentTotal = (parseFloat(currentTotal.replace(",", "."))+parseFloat(selectedPriceS )+parseFloat(selectedPriceP )).toFixed(2);

		$('#ordertotal').data('price',currentTotal);
		$('#ordertotal')[0].textContent = currentTotal;
	});

	function initSubmitOrderForm() {
		const form = document.getElementById('submitorder');
		if (!form) return; // Sicurezza
/*console.log(form);*/
		// Seleziona gli elementi all'interno del form
		const shippingRadios = form.querySelectorAll('input[name="shippingMethodRadio"]');
		const paymentRadios  = form.querySelectorAll('input[name="paymentMethodRadio"]');
		const submitButton   = document.getElementById('submitCart');/*form.querySelector('#submitCart');*/
		const termsAccepted = document.getElementById('acceptedTerms');

/*console.log(shippingRadios);
console.log(paymentRadios);
console.log(submitButton);
console.log(termsAccepted);*/
		// Verifica se un radio del gruppo shipping è selezionato
		// function isShippingSelected() {//sempre true perchè beni online
		// 	return Array.from(shippingRadios).some(radio => radio.checked);
		// 	//return true;
		// }
		//
		// // Verifica se un radio del gruppo payment è selezionato
		// function isPaymentSelected() {
		// 	return Array.from(paymentRadios).some(radio => radio.checked);
		// }
		//
		// function isTermsAccepted() {
		// 	return document.getElementById('acceptedTerms').checked;
		// }
		//
		// // Aggiorna lo stato dei radio e del bottone submit
		// function updateFormState() {
		// 	if (isShippingSelected()) {
		// 		// Abilita i radio di pagamento se è stato scelto un metodo di spedizione
		// 		Array.from(paymentRadios).forEach(radio => radio.disabled = false);
		// 	} else {
		// 		// Se nessun metodo di spedizione è selezionato, disabilita e deseleziona i radio di pagamento
		// 		Array.from(paymentRadios).forEach(radio => {
		// 			radio.checked = false;
		// 			radio.disabled = true;
		// 		});
		// 	}
		//
		// 	submitButton.disabled = !(isShippingSelected() && isPaymentSelected() && isTermsAccepted());
		// }

		/*// Stato iniziale
		if (shippingRadios.length === 0) {console.log("Shipping radios vuoti");
			submitButton.disabled = true;
			Array.from(paymentRadios).forEach(radio => radio.disabled = true);
		}else{
			submitButton.disabled = true;
		}*/

		// // Aggiunge l'evento change a ciascun radio del form
		// Array.from(shippingRadios).forEach(radio => {
		// 	radio.addEventListener('change', updateFormState);
		// });
		// Array.from(paymentRadios).forEach(radio => {
		// 	radio.addEventListener('change', updateFormState);
		// });
		// termsAccepted.addEventListener('change', (event) => {
    	// 	const isChecked = event.target.checked;
    	// 	updateFormState();
		// });

	}

// Verifica se il form "submitorder" è già presente in pagina
	if (document.getElementById('submitorder')) {
		initSubmitOrderForm();
	} else {
		// Se non presente, utilizza un MutationObserver per attendere la sua comparsa
		const observer = new MutationObserver((mutations, obs) => {
			if (document.getElementById('submitorder')) {
				initSubmitOrderForm();
				obs.disconnect(); // Interrompe l'osservazione una volta trovato il form
			}
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}

	$(document).on('click', '.js-plus, .js-minus', function (event) {
		//count managed on hs.quantity-counter.js
		event.preventDefault();
		const clickedElement    = $(event.target);
		const closestPlus       = clickedElement.closest('.js-plus');
		const closestMinus      = clickedElement.closest('.js-minus');

		let elem                = $(this).attr('data-id');
		let tmp                 = elem.split('-'); let tmp_name = tmp[1];//itemId
		let relativeCount   = document.getElementsByName('products['+tmp_name+']amount');
		let itemAmount          = $(relativeCount).val();//counter
		let prevItemAmount      = $(document.getElementsByName('prevamount-'+tmp_name)).val();//prev counter

		/*let quantity        = parseInt(itemAmount) - parseInt(prevItemAmount);*/
		let itemNewAmount  = parseInt(itemAmount);
		let quantity       = 0;
		let closestId       = '';
		if (closestPlus.length) {
			//console.log('Clicked on plus');
			quantity        = quantity + 1;
			itemNewAmount   = itemNewAmount + 1;
			/*closestId       = 'plus-'+tmp_name;*/
		} else if (closestMinus.length) {
			//console.log('Clicked on minus');
			quantity        = quantity - 1;
			itemNewAmount   = itemNewAmount - 1;
			if(itemNewAmount < 0){
				itemNewAmount   = 0;
				quantity        = 0;
			}
			/*closestId       = 'minus-'+tmp_name;*/
		}

		if(itemNewAmount === 1){/* todo: per jacopo... fare in modo che caricihi il cestino bootstrap*/
			$(document.getElementById('minus-'+tmp_name)).html('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">\n' +
				'  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>\n' +
				'  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>\n' +
				'</svg>');
		}else {
			$(document.getElementById('minus-'+tmp_name)).html('<small className="fas fa-minus btn-icon__inner">-</small>');
		}


		if(itemNewAmount === 0){//item deletion if qty = 0
			const productIdToDelete = tmp_name;
			const elements = document.querySelectorAll('[id^="removeItem-"]');
			let elementToDelete = null;
			elements.forEach(element => {
				if (element.dataset.productid === productIdToDelete.toString()) {
					elementToDelete = element;
				}
			});
			if (elementToDelete) {
				//console.log(elementToDelete);
				console.log("clicco elimino!");
				elementToDelete.click();
			}
		} else {
			let productID = tmp_name;
			let langSc = $('#lngshrtcd').val();
			let ajaxUrl = '/' + langSc + '/add_to_cart';

			$.ajax({
				url: ajaxUrl,
				data: JSON.stringify({"productId": productID, "quantity": quantity}),
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				dataType: "json",
				success: function (data) {
					//console.log(data)
					if (data.success) {
						if (typeof (data.datalayer) !== 'undefined' && data.datalayer !== null) {
							window.dataLayer.push(JSON.parse(data.datalayer));
						}

						let relativePrice = document.getElementById('price-' + tmp_name);
						let itemPrice = $(relativePrice).text().split(' ')[0]; //item's price
						itemPrice = itemPrice.replace('.', '');
						itemPrice = parseFloat(itemPrice.replace(',', '.')).toFixed(2);

						let itemTotalval = parseFloat(parseInt(itemNewAmount) * itemPrice).toFixed(2); //itemTotal value now updated (here)
						itemTotalval = new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2}).format(itemTotalval);

						$(document.getElementById('itemtotal-' + tmp_name)).text(function () {
							return $(this).text().replace($(document.getElementById('itemtotal-' + tmp_name)).text().split(' ')[0], itemTotalval);
						});


						//qt prod
						$(document.getElementById('products[' + tmp_name + ']amount')).val(itemNewAmount);

						let subtotal = parseFloat('0.00').toFixed(2);
						let elItemPrice = 0;
						let elId = 0;
						$('span[id^="price-"]').each(function (el) {
							elId = $(this).attr('id').split('-')[1];//item's Id
							elItemPrice = $(this).text().split(' ')[0]; //item's price
							elItemPrice = elItemPrice.replace('.', '');
							elItemPrice = parseFloat(elItemPrice.replace(',', '.')).toFixed(2);
							let elrelativeCount = document.getElementsByName('products[' + elId + ']amount');
							let elitemAmount = parseInt($(elrelativeCount).val());//counter
							subtotal = (+subtotal) + (+parseFloat(elitemAmount * elItemPrice).toFixed(2));
							//console.log([elId,elItemPrice,elitemAmount,subtotal]);
							//console.log(new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(subtotal));
						});

						//cart subtotal
						$(document.getElementById('subtotal')).text(function () {
							return $(this).text().replace($(document.getElementById('subtotal')).text().split(' ')[0], new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2}).format(subtotal));
						});

						//cart total
						$(document.getElementById('cartamount')).text(function () {
							return $(this).text().replace($(document.getElementById('cartamount')).text().split(' ')[0], new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2}).format(subtotal));
						});

						//scalapay widget
						let cartTotal = Number(subtotal);

						//prev update
						$(document.getElementsByName('prevamount-' + tmp_name)).val(itemAmount);
						/*console.log("cartTotal: " + cartTotal);
                        console.log("cartqty: " + data.cartqty);*/
						//bag counter
						$(document.getElementById('cart-quantity')).text(data.cartqty);

						if (subtotal === 0) {
							printEmptyCart();
						}
					} else {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
					}
				},
				statusCode: {
					404: function () {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html("Not Found");
						modalResponse.show();
					}
				}
			});
		}
	});

	$(document).on('click', '#send-coupon-code', function (event) {
		event.preventDefault();
		let swalText = $(document.getElementById('coupon-code')).data('stext');
		if($(document.getElementById('coupon-code')).val() != '') {
			let couponCode = $(document.getElementById('coupon-code')).val();
			let langsc = $('#lngshrtcd').val();
			let ajaxUrl = '/' + langsc + '/add_to_cart';

			$.ajax({
				url: ajaxUrl,
				data: JSON.stringify({"couponCode": couponCode}),
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				dataType: "json",
				success: function (data) {
					console.log(data)
					if (data.success) {
						modalResponseKo.addClass('d-none');
						modalResponseOk.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
						document.getElementById('modalResponse').addEventListener('hidden.bs.modal', event => {
							window.location.href = data.redirectval;
						});
					} else {
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(data.message);
						modalResponse.show();
					}
				},
				statusCode: {
					404: function () {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html("not found");
						modalResponse.show();
					}
				}
			});
		} else {
			if (loader !== null) {    loader.style.display = 'none';}
			modalResponseOk.addClass('d-none');
			modalResponseKo.removeClass('d-none');
			modalResponseTitle.removeClass('d-none').html(swalText);
			modalResponse.show();
		}
	});

	/** SF API */
	$("#vatCheckSeminarModal").on("submit", function (event) {
		event.preventDefault();

		var piva = document.getElementById('vatCheck').value;
		var opportunityid = "";
		var price,quantity = 0;
		for (const param of window.location.search.replace("?","").split("&")) {
			const [key, value] = param.split('=');
			if (key === 'optid') {
				opportunityid = value;
			}else if(key === 'prc') {
				price = parseFloat(value);
			}else if(key === 'qty') {
				quantity = parseFloat(value);
			}
		}
		const loader = document.getElementById('loader') || null;
		let langSc = $('#lngshrtcd').val();
		let checkVatUrl = '/' + langSc + '/checkout_register_piva_check';
		if (loader !== null) {
    			loader.style.display = 'block';
		}

		/*$.ajax({
			url: checkVatUrl,
			dataType: "json",
			method: "POST",
			data: {
				piva: piva,
			},
			success: function (response) {
				if (loader !== null) {
    				loader.style.display = 'none';
				}
				if(response.success && response.success === 'true'){
					if (loader !== null) {
    					loader.style.display = 'block';
					}*/
					$.ajax({
						url: "/api/salesforce/vatcheck",
						dataType: "json",
						method: "POST",
						data: {
							piva: piva,
							opportunityid: opportunityid,
							price: price,
							quantity: quantity,
						},
						success: function (response) {
							if (loader !== null) {
								loader.style.display = 'none';
							}
							if (response.success) {
								let langSc = $('#lngshrtcd').val();
								let ajaxUrl = '/' + langSc + '/add_to_cart';
								let productID = document.getElementById("productID").value;
								let quantity = response.data.Quantity;
								$.ajax({
									url: ajaxUrl,
									data: JSON.stringify({"productId": productID, "quantity": quantity, "opportunityId": opportunityid}),
									cache: false,
									contentType: false,
									processData: false,
									type: 'POST',
									dataType: "json",
									success: function (data) {
										//console.log(data)
										if (data.success) {
											if (typeof (data.datalayer) !== 'undefined' && data.datalayer !== null) {
												window.dataLayer.push(JSON.parse(data.datalayer));
											}
											document.getElementById("cart-quantity").innerText = quantity;
											document.getElementById("cart-quantity").classList.add("cart-quantity-filled");

											document.getElementById("vatcheck_title").innerText = document.getElementById("field_ready").value;
											document.getElementById("vatcheck_description").innerText = document.getElementById("field_ready_subtitle").value;
											document.getElementById("vatCheckSeminarModal").classList.add("d-none");
											document.getElementById("vatcheck_button").classList.remove("d-none");
											// document.getElementById("vatcheck_button").href = '/' + langSc + '/view_cart';
											$("#vatCheckSeminarModal").modal("hide");
										}else{

										}

									}
								});
							} else if (!response.success || JSON.stringify(response) === "{}") {
								document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").style.display = "block";
								document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").innerHTML = response.message;
								document.querySelector("#vatCheckSeminarModal > div.row > div.col-md-6.d-none").classList.remove("d-none");
							}
						},
						error: function (xhr, status, error) {
							if (loader !== null) {
								loader.style.display = 'none';
							}
							if (xhr.status === 404) {
								modalResponseOk.addClass('d-none');
								modalResponseKo.removeClass('d-none');
								modalResponseTitle.removeClass('d-none').html("URL non trovato.");
								modalResponse.show();
							} else {
								modalResponseOk.addClass('d-none');
								modalResponseKo.removeClass('d-none');
								modalResponseTitle.removeClass('d-none').html("Errore di comunicazione con il server.");
								modalResponse.show();
							}
						}
					});
				/*} else if(response.success && response.success === 'false'){
					if (loader !== null) {
						loader.style.display = 'none';
					}
					document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").style.display = "block";
					document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").innerHTML = response.message;
					document.querySelector("#vatCheckSeminarModal > div.row > div.col-md-6.d-none").classList.remove("d-none");

				}else if (!response.success) {
					if (loader !== null) {
						loader.style.display = 'none';
					}
					document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").style.display = "block";
					document.querySelector("#vatCheckSeminarModal > div.mb-3 > div").innerHTML = response.message;
					document.querySelector("#vatCheckSeminarModal > div.row > div.col-md-6.d-none").classList.remove("d-none");
				}
			},
			error: function (xhr, status, error) {
				//todo: intercettare errore non sto passando response
				if (loader !== null) {    loader.style.display = 'none';}
				if (xhr.status === 404) {
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html("URL non trovato.");
					modalResponse.show();
				} else {
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html('errore generico');
					modalResponse.show();
				}
			}
		});*/

	});

	function printEmptyCart(){
		$(document.getElementById('cart-table')).remove();
		$(document.getElementById('cart-total')).remove();
		$('<div class="mb-8">\n' +
			'        <div class="row">\n' +
			'            <div class="col-12 text-center">\n' +
			'                <i class="ec ec-add-to-cart font-size-50"></i>\n' +
			'                <h2>'+ $(document.getElementById('field_emptycart')).val() + '!</h2>\n' +
			'                <p>'+ $(document.getElementById('field_addprodbeforeproceed')).val() + '</p>\n' +
			'                <a href="'+ $(document.getElementById('field_newurl')).val() + '" class="btn btn-primary">'+ $(document.getElementById('field_chooseprods')).val() + '</a>\n' +
			'            </div>\n' +
			'        </div>\n' +
			'    </div>' +
			'<span style="visibility: hidden" id="cartamount">0,00</span>').appendTo('#cartcontainer');
	}

	// Handle password change form visibility
	$('#checkchangepsw').on('change', function () {
		if ($(this).is(':checked')) {
			$('#changepsw').removeClass('d-none');
			$('#inputRefConfirmPassword').prop('required', true);
		} else {
			$('#changepsw').addClass('d-none');
			$('#inputRefConfirmPassword').prop('required', false);
		}
	});

	function loadPostJS(clientToken,formObj) {
		let scriptEle = document.createElement("script");
		let cid = $('#paypal-client-id').val();
		/*let url = 'https://www.paypal.com/sdk/js?components=hosted-fields,buttons&client-id='+cid+'&disable-funding=sofort,mybank&currency=EUR&locale=en_US';*/
		let url = 'https://www.paypal.com/sdk/js?components=hosted-fields,buttons&client-id='+cid+'&disable-funding=sofort,mybank&currency=EUR&locale=it_IT';

		scriptEle.setAttribute("src", url);
		scriptEle.setAttribute("type", "text/javascript");
		scriptEle.setAttribute("async", 'true');
		scriptEle.setAttribute("data-client-token", clientToken);

		document.body.appendChild(scriptEle);

		// success event
		scriptEle.addEventListener("load", () => {
			console.log("script loaded, carico paypalButtons");
			paypalButtons(formObj);
		});
		// error event
		scriptEle.addEventListener("error", (ev) => {
			console.log("Error on loading script", ev);
		});
	}

	function paypalButtons(formObj){
		console.log("paypalButtons");
		let spinner           = $('#loader');
		let orderID           = document.getElementById('orderid').value;
		const lang_shortcode  = $('#lang-shortcode').val();
console.log(lang_shortcode, orderID);
/*alert(lang_shortcode);alert(orderID);*/
		const paypal_co_url = '/' + lang_shortcode + '/paypal_create_order';
		const paypal_c_url  = '/' + lang_shortcode + '/paypal_capture';
		const paypal_cb_url = '/' + lang_shortcode + '/paypal_capture_button';
		const paypal_err_url= '/' + lang_shortcode + '/paypal_error';
		const paypal_thanks = '/' + lang_shortcode + '/thank_you_page';

		const error_paypal_attention    = document.getElementById('error_paypal_attention').value;
		const error_paypal_generic      = document.getElementById('error_paypal_generic').value;
		const error_paypal_404          = document.getElementById('error_paypal_404').value;
		const error_paypal_500          = document.getElementById('error_paypal_500').value;//error_500_title
		const paypal_n_card_number      = document.getElementById('paypal_n_card_number').value;

		let form    = document.querySelector('#paypal-form');
		let o ;
console.log(form);
		try {
			/*todo inserito per far apparire il radio PRIMA che isEligible sia verificato */
			/*document.querySelectorAll('#paypal-modal .radio.hidden').forEach(el => {
				el.classList.remove('hidden');
				el.style.display = 'block';
			});*/
			console.log(paypal);
			/*paypal credit card management*/
			/*todo: commentato via perchè non gestita al momento*/
			/*if (paypal.HostedFields.isEligible() === true) {
				console.log("hostedfiels is eligible");
				paypal.HostedFields.render({
					createOrder: () => {
						// logic to return an order ID from your server
						return fetch(paypal_co_url,
							{
								method: 'POST',
								body: formObj.serialize(),
								headers: {
									'Content-type': 'application/json; charset=UTF-8',
								}
							}
						).then(function (res) {
							return res.json();
						}).then(function (data) {
							console.log(data);
							if (data === null) {
								console.log(error_paypal_generic);
								alert(error_paypal_generic);
								/!*Swal.fire({
									title:  error_paypal_attention,
									html:   error_paypal_generic,
									icon:   "error",
									showCancelButton: false,
									confirmButtonText: "Ok",
									confirmButtonColor: '#0D4DA1'
								});*!/
							} else {
								return data.id;
							}
						});
					},
					styles: {
						'input': {
							'font-size': '14px',
							'font-family': 'Product Sans',
							'color': '#3a3a3a'
						},
						// Style the text of an invalid input
						'input.invalid': {
							'color': '#E53A40'
						},
					},
					fields: {
						number: {
							selector: '#card-number',
							placeholder: paypal_n_card_number,
						},
						cvv: {
							selector: '#cvv',
							placeholder: 'CVV',
						},
						expirationDate: {
							selector: '#expiration-date',
							placeholder: 'MM/AA',
						}
					}
				}).then((hostedFields) => {
					hostedFields.on('validityChange', function (event) {
						console.log('CCF Event "validityChange", state=' + hostedFields.getState() + ",event=" + event);
						// Check if all fields are valid, then show submit button
						var formValid = Object.keys(event.fields).every(function (key) {
							return event.fields[key].isValid;
						});

						if (formValid) {
							$('#button-pay').addClass('show-button');
						} else {
							$('#button-pay').removeClass('show-button');
						}
					});
					var cvvLabel = document.querySelector('label[for="cvv"]'); // The label for your CVV field
					hostedFields.on('cardTypeChange', function (event) {
						console.log('CCF Event "cardTypeChange", state=' + hostedFields.getState() + ",event=" + event);
						console.log(event);

						// Change card bg depending on card type
						if (event.cards.length === 1) {
							$(form).removeClass().addClass(event.cards[0].type);
							$('#card-image').removeClass().addClass(event.cards[0].type);
							console.log('CCF Card Type ' + event.cards[0].niceType);


							// Change the CVV length for AmericanExpress cards
							if (event.cards[0].code.size === 4) {
								hostedFields.setAttribute({
									field: 'cvv',
									attribute: 'placeholder',
									value: '1234'
								});

							}
						} else {
							hostedFields.setAttribute({
								field: 'cvv',
								attribute: 'placeholder',
								value: '123'
							});

						}
					});

					document.querySelector('#paypal-form').addEventListener('submit', (event) => {
						$('#paypal-modal').modal('hide');
						event.preventDefault();
						// spinner.show();
						hostedFields.submit({
							// Need to specify when triggering 3D Secure authentication
							// SCA_WHEN_REQUIRED  or  3D_SECURE
							contingencies: ['3D_SECURE']
						}).then(payload => {
							return fetch(paypal_c_url,/!*!/paypal-capture.html?id=" + payload.orderId*!/
								{
									headers: {
										'Accept': 'application/json',
										'Content-Type': 'application/json'
									},
									method: 'POST',
									body:   formObj.serialize()+'&id=' +payload.orderId
								}
							).then((response) => response.json()
							).then((data) => {
								$('#loader').hide();
								console.log(data);
								if(data.status == 'COMPLETED'){
									window.location = paypal_thanks + '?orderid='+data.paymentTk+'&reference='+data.reference+'&state=completed';
								}else{
									Swal.fire({
										title:  "",
										html:   data.message,
										icon:   "error",
										showCancelButton: false,
										confirmButtonText: "Ok",
										confirmButtonColor: '#0D4DA1'
									});
								}
								return data.id;
							});
						}).catch(
							(reason) => {
								$('#loader').hide();
								console.log( reason );
								alert(reason.details[0].description);
								/!*Swal.fire({
									title:  reason.name,
									html:   reason.details[0].description,
									icon:   "error",
									showCancelButton: false,
									confirmButtonText: "Ok",
									confirmButtonColor: '#0D4DA1'
								});*!/
							});
					});

				});
			}else{
				console.log("non era eligible");
			}*/

			//////////////////////PayPal button
			paypal.Buttons({
				style: {
					layout: 'horizontal',
					color: 'gold',
					shape: 'rect',
					label: 'paypal',
					tagline: false
				},
				createOrder: function (data, actions) {
					$("#placeholder").removeClass('hidden');

					return fetch(paypal_co_url,
						{
							method: 'POST',
							body:   formObj.serialize(),
							headers: {
								'Content-type': 'application/json; charset=UTF-8',
							}
						}
					).then(function (res) {/*console.log(res);*/
						return res.json();
					}).then(function (data) {//console.log(data);
						$("#placeholder").addClass('hidden')
						if (data === null) {

							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(error_paypal_generic);
							modalResponse.show();

						} else if(data.status == 'error' || data.status == 'INVALID_REQUEST' || data.status == 'UNPROCESSABLE_ENTITY' || data.name == 'INVALID_REQUEST' || data.name == 'UNPROCESSABLE_ENTITY'){
							console.log(data);
							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
							return data.id;
						}else {
							//console.log(data.id);
							return data.id;
						}

						return data.id;
					});
				},
				onApprove: function (data, actions) {

					return fetch(paypal_cb_url,
						{
							method: 'POST',
							body: formObj.serialize() + '&pporderId=' + data.orderID + '&orderid=' + orderID,
							headers: {
								'Content-type': 'application/json; charset=UTF-8',
							}
						}
					).then(function (res) {
						return res.json();
					}).then(function (data) {
						if(data.status == 'ERROR' || data.status == 'error'){

							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(data.message);
							modalResponse.show();
						}else if(data.status == 'success'){
							spinner.show();
							window.location = paypal_thanks + '?orderid='+data.paymentTk+'&reference='+data.reference+'&state=completed';
						}
						return data.id;
					});
				},onError: function (data){

					let errMessage = data.message;
					if(data.message ){
						console.log(data.message);
						errMessage = error_paypal_generic;
					}

					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html(errMessage);
					modalResponse.show();
				}
			}).render('#paypal-button-container');
			/////////////////////////////////
		}catch (error){

			console.log(error);

			if (loader !== null) {    loader.style.display = 'none';}
			modalResponseOk.addClass('d-none');
			modalResponseKo.removeClass('d-none');
			modalResponseTitle.removeClass('d-none').html(error_paypal_generic);
			modalResponse.show();
		}
	}
	/* CART fine */

	function gestisciFormConModale(idFormPrincipale, idModale, idFormModale, idBottoneSubmitPrincipale) {
		console.log(idFormPrincipale, idModale, idFormModale, idBottoneSubmitPrincipale);
		const $formPrincipale = $('#' + idFormPrincipale);
		const $modale = $('#' + idModale);
		const $formModale = $('#' + idFormModale);
        const loader = document.getElementById('loader') || null;
		let $bottoneSubmitPrincipale = $('#' + idBottoneSubmitPrincipale);

		$bottoneSubmitPrincipale.on('click', function(event) {console.log("modale0?");
			event.preventDefault();
			$modale.modal('show');
			console.log("Il form principale non può essere inviato finché il form nella modale non è stato inviato con successo.");
		});

		let langsc = $('#lngshrtcd').val();

		if ($formPrincipale.length < 0 || !$modale.length < 0 || !$formModale.length < 0 || !$bottoneSubmitPrincipale.length < 0) {
			console.error("Uno degli ID forniti non corrisponde a nessun elemento nel DOM.");
			return;
		}

		$formModale.on('submit', function(event) {
			event.preventDefault();
			const oldParticipantName 	= $formModale.find('input[id="participant[oldname]"]').val() || '';
			const oldParticipantSurname = $formModale.find('input[id="participant[oldlastname]"]').val() || '';
			const oldParticipantEmail 	= $formModale.find('input[id="participant[oldemail]"]').val() || '';
			const oldParticipantPhone 	= $formModale.find('input[id="participant[oldphone]"]').val() || '';
			const newParticipantName 	= $formModale.find('input[id="participant[name]"]').val() || '';
			const newParticipantSurname = $formModale.find('input[id="participant[lastname]"]').val() || '';
			const newParticipantEmail 	= $formModale.find('input[id="participant[email]"]').val() || '';
			const newParticipantPhone 	= $formModale.find('input[id="participant[phone]"]').val() || '';
			let formData = $formModale.serialize();
			$.ajax({
				url: '/api/salesforce/participants',
				type: 'POST',
				data: formData,
				dataType: 'json',
				success: function (response) {
					if (response.success) {
						console.log(response.action);
                        console.log(response.success);

						let modalParticipantsSurname = $(`input[id^="participant[lastname]"]`);
						/*if (response.hasOwnProperty('action') && response.action === "update") {
						}*/
						$("#modalParticipants").modal("hide");
						let msg_err = ''; let error = false;
						/* required fields */
						if($('#firstName').val() ==''){
							error = true;
							msg_err = $('#firstName').data('msg');
						}
						if($('#lastName').val() ==''){
							error = true;
							msg_err = $('#lastName').data('msg');
						}
						if($('#street').val() ==''){
							error = true;
							msg_err = $('#street').data('msg');
						}
						if($('#cityAddress').val() ==''){
							error = true;
							msg_err = $('#cityAddress').data('msg');
						}
						if($('#cityAddress').val() ==''){
							error = true;
							msg_err = $('#cityAddress').data('msg');
						}
						if($('#housenumber').val() ==''){
							error = true;
							msg_err = $('#housenumber').data('msg');
						}

						if($('#administrativearea').val() === 0 || $('#administrativearea').val() ==''){
							error = true;
							msg_err = $('#administrativearea').data('msg');
						}
						if($('#state').val() === 0 || $('#state').val() ==''){
							error = true;
							msg_err = $('#state').data('msg');
						}
						if($('#emailAddress').val() ==''){
							error = true;
							msg_err = $('#emailAddress').data('msg');
						}
						if($('#phone').val() === 0 || $('#phone').val() ==''){
							error = true;
							msg_err = $('#phone').data('msg');
						}
						if (response.hasOwnProperty('action') && response.action === "update") {
							if(oldParticipantName !== '' && oldParticipantSurname !== '' && oldParticipantEmail !== '' && oldParticipantPhone !== '' && newParticipantName !== '' && newParticipantSurname !== '' && newParticipantEmail !== '' && newParticipantPhone !== ''){
								if(oldParticipantName !== newParticipantName || oldParticipantSurname !== newParticipantSurname || oldParticipantEmail !== newParticipantEmail || oldParticipantPhone !== newParticipantPhone){
									error = false;
									html_msg = '<h2>Aggiornamento eseguito con successo</h2><br>';
									html_button_msg = 'Ricarica Pagina';
									modalResponseKo.addClass('d-none');
									modalResponseOk.removeClass('d-none');
									modalResponseTitle.removeClass('d-none').html(html_msg);
									modalResponseLinks.addClass('text-center')
									modalHiddenP.removeClass('d-none');
									modalResponseButtonElhidden.removeClass('d-none').html(html_button_msg);
									modalResponse.show();
									$('#modalHiddenP').on('click', '#modalResponseButtonElhidden', function() {
										location.reload();
									});
								}
							}
						}

						if(error === false){
							console.log($bottoneSubmitPrincipale.parents( 'form' ));
							parseForm($bottoneSubmitPrincipale);
						} else {
							if (loader !== null) {    loader.style.display = 'none';}
							modalResponseOk.addClass('d-none');
							modalResponseKo.removeClass('d-none');
							modalResponseTitle.removeClass('d-none').html(msg_err);
							modalResponse.show();
						}
					} else {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(response.message);
						modalResponse.show();
					}
				},
				error: function () {
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html("Error submitting form");
					modalResponse.show();
				}
			});
		});
	}

	gestisciFormConModale('shipping', 'modalParticipants', 'modalParticipantsForm', 'shippingCheckoutForm');

	function gestisciFormConModaleRemove(idModale, idFormModale) {
		const modale = $('#' + idModale);
		const formModale = $('#' + idFormModale);
        const loader = document.getElementById('loader') || null;
		let langsc = $('#lngshrtcd').val();

		if (!modale.length < 0 || !formModale.length < 0 ) {
			console.error("Uno degli ID forniti non corrisponde a nessun elemento nel DOM.");
			return;
		}
		formModale.on('submit', function(event) {
			event.preventDefault();
			let formData = formModale.serialize();
			let modale2 =  $('#modalParticipantsRemove');
			let idParticipant = modale2.find('#idPart').html();

			$.ajax({
				url: '/api/salesforce/participants',
				type: 'POST',
				data: formData,
				dataType: 'json',
				success: function (response) {
					if (response.success) {
                        console.log(response);
						$("#modalParticipantsRemove").modal("hide");
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						var html_msg = response.message + '<br><br>';
						if(response.refund === 1){
							html_msg = html_msg + 'E\' stato richiesto il rimborso.';
						}else{
							html_msg = html_msg + 'Non è stato possibile richiedere il rimborso.';
						}
						
                        modalResponseTitle.removeClass('d-none').html(html_msg);
                        modalResponseLinks.addClass('text-center')
						modalResponse.show();
						$('#partecipants-'+idParticipant).remove();
					} else {
						if (loader !== null) {    loader.style.display = 'none';}
						modalResponseOk.addClass('d-none');
						modalResponseKo.removeClass('d-none');
						modalResponseTitle.removeClass('d-none').html(response.message);
						modalResponse.show();
					}
				},
				error: function () {
					console.log("errore chiamata salesforce");
					if (loader !== null) {    loader.style.display = 'none';}
					modalResponseOk.addClass('d-none');
					modalResponseKo.removeClass('d-none');
					modalResponseTitle.removeClass('d-none').html("Error submitting form");
					modalResponse.show();
				}
			});
		});
	}

	gestisciFormConModaleRemove('modalParticipantsRemove', 'modalParticipantsRemoveForm');
});

function togglePassword(input) {
    const inputPassword = document.getElementById(input);
    if (inputPassword.type === "password") {
        inputPassword.type = "text";
        document.getElementById('icon-password').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">\n' +
            '  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>\n' +
            '  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>\n' +
            '</svg>';

    } else {
        inputPassword.type = "password";
        document.getElementById('icon-password').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">\n' +
            '  <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>\n' +
            '  <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>\n' +
            '  <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>\n' +
            '</svg>';
    }
}


const ready = (callback) => {

	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);

}


// Doc ready

ready(() => {


	const toggler       = document.querySelector('.navbar-toggler');
	let navbarHeight            = $('#header').outerHeight(true);
	let delta           = 5;
	let lastScrollTop   = 0;
	let togglerOpen     = false;
	let didScroll;


	function getWindowWidth() {
		return $( window ).width();
	}

	function togglerState() {
		togglerOpen = !togglerOpen;
	}

	function hasScrolled() {

		if(getWindowWidth() < 991) {

			let scrollTop = $(this).scrollTop();

			// Delta min scroll
			if (Math.abs(lastScrollTop - scrollTop) <= delta) {
				return;
			}

			// If top remove scrolldown
			if (scrollTop <= 0) {
				$('body').removeClass('scroll-down')
				return;
			}

			if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
				// Scroll Down
				if (!togglerOpen) {
					$('[data-bs-toggle="dropdown"]').dropdown('hide').blur();
					$('body').removeClass('scroll-up').addClass('scroll-down');
				}
			} else {
				// Scroll Up
				if (!togglerOpen) {
					if (scrollTop + $(window).height() < $(document).height()) {
						$('body').removeClass('scroll-down').addClass('scroll-up');
					}
				}
			}

			lastScrollTop = scrollTop;

		}
	}

	if (toggler) {
		toggler.addEventListener('click', togglerState);
	}



	$(window).scroll(function(){
		if (!togglerOpen) {
			didScroll = true;
		}
	});

	$(window).on('resize', function(){
		$('body').removeClass('scroll-down').addClass('scroll-up');
	});

	// Toggle scroll function state for collapse and anchor links
	$('#header [data-bs-toggle="collapse"]').click(function() {
		togglerOpen = true;
	});
	$('.navbar-collapse').on('hidden.bs.collapse', function () {
		togglerOpen = false;
	});
	$('.navbar-collapse a[href^="#"]:not([href="#"])').click(function () {
		togglerOpen = true;
	});


	// Scroll func performance
	setInterval(function() {
		toggleBacktotop();
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);




	// SMOOTH SCROLL TO ANCHORS

	const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"]):not([href^="#collapseProgram"]):not([href^="#collapseOrder"])');

	anchors.forEach(trigger => {

		trigger.onclick = function(e) {

			e.preventDefault();
			let hash = this.getAttribute('href');
			let target = document.querySelector(hash);
			let elementPosition = target.offsetTop;
			let headerOffset = $('#header').outerHeight(true);
			let offsetPosition = elementPosition - headerOffset;

			window.scrollTo({

				top: offsetPosition,
				behavior: 'smooth'

			});

			// Wait scroll function to resume scroll func
			setTimeout(function(){
				togglerOpen = false;
			}, 1000);

		};
	});




	// BACK TO TOP

	const topButton = document.getElementById('top');

	function backToTop() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}

	function toggleBacktotop() {
		if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
			topButton.style.display = 'block';
		} else {
			topButton.style.display = 'none';
		}
	}

	if(topButton) {
		topButton.addEventListener('click', backToTop);
	}




	// Offcanvas menu nav

	const offcanvasNav = document.getElementById('offcanvasNav');
	const navbarTogglerIcon = document.getElementById('navbarTogglerIcon');
	offcanvasNav.addEventListener('show.bs.offcanvas', event => {
		navbarTogglerIcon.classList.add('closehamb');
	});
	offcanvasNav.addEventListener('hide.bs.offcanvas', event => {
		navbarTogglerIcon.classList.remove('closehamb');
	});




	// Clone desktop sidebar filters to mobile aside offcanvas and vice versa

	const mediaQuery = '(max-width: 991.98px)';
	const mediaQueryList = window.matchMedia(mediaQuery);
	let offcanvasFilters = $('#offcanvasFilters');
	let sidebarListing = $('#listingSidebarContent');

	if (offcanvasFilters) {

		if (mediaQueryList.matches) {

			offcanvasFilters.append(sidebarListing.children().clone());
			sidebarListing.empty();

		}

		mediaQueryList.addEventListener('change', event => {

			if (event.matches) {

				offcanvasFilters.append(sidebarListing.children().clone());
				sidebarListing.empty();

			} else {

				sidebarListing.append(offcanvasFilters.children().clone());
				offcanvasFilters.empty();
				let ocbs = bootstrap.Offcanvas.getInstance(offcanvasFilters[0]);
				if(ocbs) {
					ocbs.hide();
				}

			}

		})

	}





	// PRINT BUTTON

	const printButton = document.getElementById('printButton');

	function printPage() {
		window.print();
	}

	if(printButton) {
		printButton.addEventListener('click', printPage);
	}



	// SHARE BUTTON

	const shareButton = document.getElementById('shareButton');

	if(shareButton) {

		shareButton.addEventListener('click', function () {

			let shareModal = new bootstrap.Modal(document.getElementById('shareModal'));
			shareModal.show();

		});

	}



	// EVENT REGISTER BUTTON
	const eventRegButton = document.getElementById('eventRegButton');

	if(eventRegButton) {

		 eventRegButton.addEventListener('click', function () {

			let EventRegModal = new bootstrap.Modal(document.getElementById('EventRegModal'));
			EventRegModal.show();

		});

	}



	// My Orders Partecipants Forms

		// Remove
		const removeButtons = document.querySelectorAll('[id^="removePartecipant-"]');

		if (removeButtons.length > 0) {

			let modalParticipantsRemove				= new bootstrap.Modal(document.getElementById('modalParticipantsRemove'), {
				keyboard: false,
				backdrop: 'static',
				focus: true
			});

			removeButtons.forEach(function (removeButton) {
				removeButton.addEventListener('click', function (event) {
                console.log("click delete");
					event.preventDefault();

					let id								= this.id.split('-')[1];
					let opportunityId					= document.getElementById('opportunityId-' + id).value;
					let nameInput						= document.getElementById('name-' + id).value;
					let surnameInput					= document.getElementById('surname-' + id).value;
					let emailInput						= document.getElementById('email-' + id).value;
					let phoneInput						= document.getElementById('phone-' + id).value;
					let modalParticipantsRemoveTitle			= $(`#modalParticipantsRemove #idPart`);
					let modalParticipantsRemoveIdPartecipant	= $(`#modalParticipantsRemove input[id^="participantRemove[idpartecipant]"]`);
					let modalParticipantsRemoveOpportunity	= $(`#modalParticipantsRemove input[id^="participantRemove[opportunityId]"]`);
					let modalParticipantsRemoveName			= $(`#modalParticipantsRemove input[id^="participantRemove[name]"]`);
					let modalParticipantsRemoveSurname		= $(`#modalParticipantsRemove input[id^="participantRemove[lastname]"]`);
					let modalParticipantsRemoveEmail		= $(`#modalParticipantsRemove input[id^="participantRemove[email]"]`);
					let modalParticipantsRemovePhone		= $(`#modalParticipantsRemove input[id^="participantRemove[phone]"]`);
					let modalParticipantsRemoveButton		= $(`#partecipantModalRemoveSubmit`);

					modalParticipantsRemoveTitle.text(id);
					modalParticipantsRemoveIdPartecipant.val(id);
					modalParticipantsRemoveOpportunity.val(opportunityId);
					modalParticipantsRemoveName.val(nameInput);
					modalParticipantsRemoveSurname.val(surnameInput);
					modalParticipantsRemoveEmail.val(emailInput);
					modalParticipantsRemovePhone.val(phoneInput);

					modalParticipantsRemove.show();

					/*modalParticipantsRemoveButton.addEventListener('click', function (event) {
						// Todo

					})*/

				})
			})
		}


		// Edit
		const editButtons = document.querySelectorAll('[id^="editPartecipant-"]');

		if (editButtons.length > 0) {

			let modalParticipants = new bootstrap.Modal(document.getElementById('modalParticipants'), {
				keyboard: false,
				backdrop: 'static',
				focus: true
			});

			editButtons.forEach(function (editButton) {
				editButton.addEventListener('click', function (event) {
                console.log(this.id);
					event.preventDefault();

					let id = this.id.split('-')[1];
					let opportunityId = document.getElementById('opportunityId-' + id).value;
					let nameInput = document.getElementById('name-' + id).value;
					let surnameInput = document.getElementById('surname-' + id).value;
					let emailInput = document.getElementById('email-' + id).value;
					let phoneInput = document.getElementById('phone-' + id).value;
					let modalParticipantsTitle = $(`#modalParticipants #idPart`);
					let modalParticipantsIdPartecipant = $(`#modalParticipants input[id^="participant[idpartecipant]"]`);
					let modalParticipantsOpportunity = $(`#modalParticipants input[id^="participant[opportunityId]"]`);
					let modalParticipantsName = $(`#modalParticipants input[id^="participant[name]"]`);
					let modalParticipantsSurname = $(`#modalParticipants input[id^="participant[lastname]"]`);
					let modalParticipantsEmail = $(`#modalParticipants input[id^="participant[email]"]`);
					let modalParticipantsPhone = $(`#modalParticipants input[id^="participant[phone]"]`);
					let modalParticipantsOldName = $(`#modalParticipants input[id^="participant[oldname]"]`);
					let modalParticipantsOldSurname = $(`#modalParticipants input[id^="participant[oldlastname]"]`);
					let modalParticipantsOldEmail = $(`#modalParticipants input[id^="participant[oldemail]"]`);
					let modalParticipantsOldPhone = $(`#modalParticipants input[id^="participant[oldphone]"]`);

					modalParticipantsTitle.text(id);
					modalParticipantsIdPartecipant.val(id);
					modalParticipantsOpportunity.val(opportunityId);
					modalParticipantsName.val(nameInput);
					modalParticipantsSurname.val(surnameInput);
					modalParticipantsEmail.val(emailInput);
					modalParticipantsPhone.val(phoneInput);
					modalParticipantsOldName.val(nameInput);
					modalParticipantsOldSurname.val(surnameInput);
					modalParticipantsOldEmail.val(emailInput);
					modalParticipantsOldPhone.val(phoneInput);

					modalParticipants.show();

				});
			});
		}

		// Download Certificate of participation
		const certificateButtons = document.querySelectorAll('[id^="download-certificate-"]');

		if (certificateButtons.length > 0) {
			certificateButtons.forEach(function (certificateButton) {
				certificateButton.addEventListener('click', function (event) {
					event.preventDefault();
					let loader = document.getElementById('loader') || null;
					if (loader !== null) {
						loader.style.display = 'block';
						if(document.getElementById('loader-text') !== null){
							document.getElementById('loader-text').style.display = 'block';
						}
					}
					let id = this.id.split('-').pop();
					let langsc = $('#langsc').val();
					let ajaxUrl = '/' + langsc + '/download_certificate';

					$.ajax({
						type        : 'POST',
						url         : ajaxUrl,
						data        : JSON.stringify({"idOrder":id,"langsc":langsc}),
						cache       : false,
						contentType : 'application/json',
						processData : false,
						dataType    : "json",
						success: function (data) {
						   let result = null;
						   if (typeof data === 'string' || data instanceof String) {
							   result = JSON.parse(data);
						   } else {
							   result = data;
						   }
						   if(document.getElementById('loader-text') !== null){
								document.getElementById('loader-text').style.display = 'none';
						   }
						   if (result.success) {
							   if (loader !== null) {loader.style.display = 'none';}
							   //alert('download!');
							   // Eventualmente scaricare il file se disponibile
							   if (result.file) {
                                   let filePath = result.file;
                                   filePath = filePath.replace(/\\/g, '/');
								   window.location.href = result.file;
							   }
						   } else {
							   if (loader !== null) {loader.style.display = 'none';}
							   // Gestire l'errore
							   alert("Errore: " + (result.message || "Si è verificato un errore durante il download del certificato"));
						   }
					   },
					   error: function(xhr, status, error) {
							if (loader !== null) {loader.style.display = 'none';}
						   	alert("Errore nella richiesta: " + error);
					   }
					});
				});
			});
		}

	// BS form toggle password - text inputs

	const passwordButtons = document.querySelectorAll('.toggle-password');

	if (passwordButtons.length > 0) {

		passwordButtons.forEach(function (passwordButton) {

			passwordButton.addEventListener('click', function () {

				const passwordInput = passwordButton.closest('.input-group').querySelector('input');
				const iconShow = passwordButton.querySelector('.icon-show');
				const iconHide = passwordButton.querySelector('.icon-hide');

				if (passwordInput.type === "password") {
					passwordInput.type = "text";
					iconShow.classList.remove('d-none');
					iconHide.classList.add('d-none');
				} else {
					passwordInput.type = "password";
					iconShow.classList.add('d-none');
					iconHide.classList.remove('d-none');
				}

			});

		});

	}

	// TODO: HTML da implementare

	// <div class="col-12">
	// 	<label class="form-label" for="passwordtest">{{ dictionary.words.field_label_email.value|raw }}
	// 		<span class="text-danger" for="email">*</span>
	// 	</label>
	// 	<div class="input-group flex-nowrap">
	// 		<input id="passwordtest" type="password" class="form-control" value="123456789">
	// 		<span class="input-group-text toggle-password">
	// 			<svg class="icon-hide" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	// 				<g stroke-width="0"></g>
	// 				<g stroke-linecap="round" stroke-linejoin="round"></g>
	// 				<g>
	// 					<path d="M2 2L22 22" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
	// 					<path d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
	// 					<path d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
	// 				</g>
	// 			</svg>
	// 			<svg class="icon-show d-none" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	// 				<path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	// 				<path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	// 				<circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	// 			</svg>
	// 		</span>
	// 	</div>
	// </div>




	// BS form validation
	(() => {
		'use strict'

		const forms = document.querySelectorAll('.needs-validation');

		// Array.from(forms).forEach(form => {
		// 	form.addEventListener('submit', event => {
		// 		event.preventDefault();
		// 		event.stopPropagation();
		//
		// 		if (form.checkValidity()) {
		// 			form.classList.add('was-validated');
		// 			// $.ajax({
		// 			// 	// ajax ok/ko
		// 			// });
		// 			// modalResponseOk.removeClass('d-none');
		// 			// modalResponseTitle.removeClass('d-none').text('Validazione superata, lancia chiamata ajax');
		// 			// modalResponse.show();
		// 		} else {
		// 			form.classList.add('was-validated');
		// 			// modalResponseKo.removeClass('d-none');
		// 			// modalResponseTitle.removeClass('d-none').text('Validazione non superata!');
		// 			// modalResponse.show();
		// 		}
		// 	}, false);
		// });

		Array.from(forms).forEach(form => {
			form.addEventListener('submit', event => {
				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated')
			}, false)
		})
	})()




	// SWIPER CAROUSELS

	const swiperHomePartners = new Swiper('#swiperHomePartners', {

		loop: true,
		// rewind: true,
		slidesPerView: 1,
		spaceBetween: 20,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
		grabCursor: true,
		autoplay: true,
		breakpoints: {
			576: {
				slidesPerView: 2
			},
			991: {
				slidesPerView: 3
			},
			1200: {
				slidesPerView: 4
			},
			1600: {
				slidesPerView: 5
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}

	});

	const swiperAboutTestimonials = new Swiper('#swiperAboutTestimonials', {

		// loop: true,
		rewind: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
		grabCursor: true,
		// autoplay: true,
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: true,
			clickable: true
		}

	});

	const swiperPartnerSingleServiceTestimonials = new Swiper('#swiperPartnerSingleServiceTestimonials', {

		// loop: true,
		rewind: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
		grabCursor: true,
		// autoplay: true,
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: true,
			clickable: true
		}

	});

	const swipernewsHomeCategories = new Swiper('#swipernewsHomeCategories', {

		loop: true,
		// rewind: true,
		slidesPerView: 1,
		spaceBetween: 10,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
		grabCursor: true,
		autoplay: {
			delay: 4500,
		},
		breakpoints: {
			1200: {
				slidesPerView: 4
			},
			991: {
				slidesPerView: 3
			},
			576: {
				slidesPerView: 2
			}
		},
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: true,
			clickable: true
		}
	});

	const swiperEventsHomeCategories = new Swiper('#swiperEventsHomeCategories', {

		loop: true,
		// rewind: true,
		slidesPerView: 1,
		spaceBetween: 10,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
		grabCursor: true,
		autoplay: {
			delay: 4500,
		},
		breakpoints: {
			991: {
				slidesPerView: 2
			}
		},
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: true,
			clickable: true
		}
	});

	const modalSeminar = document.getElementById('modalSeminar');

	if(modalSeminar) {
		modalSeminar.addEventListener('hidden.bs.modal', function () {
			document.querySelector("#vatCheckSeminarModal > div.row > div.col-md-6.d-none").classList.add('d-none');
		});
	}

});

